// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Aller Light 400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Aller 400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Aller Gras 700.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-l-0 {
  padding-left: 0px;
}

.padding-l-1 {
  padding-left: 1px;
}

.padding-l-2 {
  padding-left: 2px;
}

.padding-l-3 {
  padding-left: 3px;
}

.padding-l-4 {
  padding-left: 4px;
}

.padding-l-5 {
  padding-left: 5px;
}

.padding-l-6 {
  padding-left: 6px;
}

.padding-l-7 {
  padding-left: 7px;
}

.padding-l-8 {
  padding-left: 8px;
}

.padding-l-9 {
  padding-left: 9px;
}

.padding-l-10 {
  padding-left: 10px;
}

.padding-l-11 {
  padding-left: 11px;
}

.padding-l-12 {
  padding-left: 12px;
}

.padding-l-13 {
  padding-left: 13px;
}

.padding-l-14 {
  padding-left: 14px;
}

.padding-l-15 {
  padding-left: 15px;
}

.padding-l-16 {
  padding-left: 16px;
}

.padding-l-17 {
  padding-left: 17px;
}

.padding-l-18 {
  padding-left: 18px;
}

.padding-l-19 {
  padding-left: 19px;
}

.padding-l-20 {
  padding-left: 20px;
}

.padding-l-21 {
  padding-left: 21px;
}

.padding-l-22 {
  padding-left: 22px;
}

.padding-l-23 {
  padding-left: 23px;
}

.padding-l-24 {
  padding-left: 24px;
}

.padding-l-25 {
  padding-left: 25px;
}

.padding-l-26 {
  padding-left: 26px;
}

.padding-l-27 {
  padding-left: 27px;
}

.padding-l-28 {
  padding-left: 28px;
}

.padding-l-29 {
  padding-left: 29px;
}

.padding-l-30 {
  padding-left: 30px;
}

.padding-l-31 {
  padding-left: 31px;
}

.padding-l-32 {
  padding-left: 32px;
}

.padding-l-33 {
  padding-left: 33px;
}

.padding-l-34 {
  padding-left: 34px;
}

.padding-l-35 {
  padding-left: 35px;
}

.padding-l-36 {
  padding-left: 36px;
}

.padding-l-37 {
  padding-left: 37px;
}

.padding-l-38 {
  padding-left: 38px;
}

.padding-l-39 {
  padding-left: 39px;
}

.padding-l-40 {
  padding-left: 40px;
}

.padding-l-41 {
  padding-left: 41px;
}

.padding-l-42 {
  padding-left: 42px;
}

.padding-l-43 {
  padding-left: 43px;
}

.padding-l-44 {
  padding-left: 44px;
}

.padding-l-45 {
  padding-left: 45px;
}

.padding-l-46 {
  padding-left: 46px;
}

.padding-l-47 {
  padding-left: 47px;
}

.padding-l-48 {
  padding-left: 48px;
}

.padding-l-49 {
  padding-left: 49px;
}

.padding-l-50 {
  padding-left: 50px;
}

.padding-l-51 {
  padding-left: 51px;
}

.padding-l-52 {
  padding-left: 52px;
}

.padding-l-53 {
  padding-left: 53px;
}

.padding-l-54 {
  padding-left: 54px;
}

.padding-l-55 {
  padding-left: 55px;
}

.padding-l-56 {
  padding-left: 56px;
}

.padding-l-57 {
  padding-left: 57px;
}

.padding-l-58 {
  padding-left: 58px;
}

.padding-l-59 {
  padding-left: 59px;
}

.padding-l-60 {
  padding-left: 60px;
}

.padding-l-61 {
  padding-left: 61px;
}

.padding-l-62 {
  padding-left: 62px;
}

.padding-l-63 {
  padding-left: 63px;
}

.padding-l-64 {
  padding-left: 64px;
}

.padding-l-65 {
  padding-left: 65px;
}

.padding-l-66 {
  padding-left: 66px;
}

.padding-l-67 {
  padding-left: 67px;
}

.padding-l-68 {
  padding-left: 68px;
}

.padding-l-69 {
  padding-left: 69px;
}

.padding-l-70 {
  padding-left: 70px;
}

.padding-l-71 {
  padding-left: 71px;
}

.padding-l-72 {
  padding-left: 72px;
}

.padding-l-73 {
  padding-left: 73px;
}

.padding-l-74 {
  padding-left: 74px;
}

.padding-l-75 {
  padding-left: 75px;
}

.padding-l-76 {
  padding-left: 76px;
}

.padding-l-77 {
  padding-left: 77px;
}

.padding-l-78 {
  padding-left: 78px;
}

.padding-l-79 {
  padding-left: 79px;
}

.padding-l-80 {
  padding-left: 80px;
}

.padding-l-81 {
  padding-left: 81px;
}

.padding-l-82 {
  padding-left: 82px;
}

.padding-l-83 {
  padding-left: 83px;
}

.padding-l-84 {
  padding-left: 84px;
}

.padding-l-85 {
  padding-left: 85px;
}

.padding-l-86 {
  padding-left: 86px;
}

.padding-l-87 {
  padding-left: 87px;
}

.padding-l-88 {
  padding-left: 88px;
}

.padding-l-89 {
  padding-left: 89px;
}

.padding-l-90 {
  padding-left: 90px;
}

.padding-l-91 {
  padding-left: 91px;
}

.padding-l-92 {
  padding-left: 92px;
}

.padding-l-93 {
  padding-left: 93px;
}

.padding-l-94 {
  padding-left: 94px;
}

.padding-l-95 {
  padding-left: 95px;
}

.padding-l-96 {
  padding-left: 96px;
}

.padding-l-97 {
  padding-left: 97px;
}

.padding-l-98 {
  padding-left: 98px;
}

.padding-l-99 {
  padding-left: 99px;
}

.padding-l-100 {
  padding-left: 100px;
}

.padding-r-0 {
  padding-right: 0px;
}

.padding-r-1 {
  padding-right: 1px;
}

.padding-r-2 {
  padding-right: 2px;
}

.padding-r-3 {
  padding-right: 3px;
}

.padding-r-4 {
  padding-right: 4px;
}

.padding-r-5 {
  padding-right: 5px;
}

.padding-r-6 {
  padding-right: 6px;
}

.padding-r-7 {
  padding-right: 7px;
}

.padding-r-8 {
  padding-right: 8px;
}

.padding-r-9 {
  padding-right: 9px;
}

.padding-r-10 {
  padding-right: 10px;
}

.padding-r-11 {
  padding-right: 11px;
}

.padding-r-12 {
  padding-right: 12px;
}

.padding-r-13 {
  padding-right: 13px;
}

.padding-r-14 {
  padding-right: 14px;
}

.padding-r-15 {
  padding-right: 15px;
}

.padding-r-16 {
  padding-right: 16px;
}

.padding-r-17 {
  padding-right: 17px;
}

.padding-r-18 {
  padding-right: 18px;
}

.padding-r-19 {
  padding-right: 19px;
}

.padding-r-20 {
  padding-right: 20px;
}

.padding-r-21 {
  padding-right: 21px;
}

.padding-r-22 {
  padding-right: 22px;
}

.padding-r-23 {
  padding-right: 23px;
}

.padding-r-24 {
  padding-right: 24px;
}

.padding-r-25 {
  padding-right: 25px;
}

.padding-r-26 {
  padding-right: 26px;
}

.padding-r-27 {
  padding-right: 27px;
}

.padding-r-28 {
  padding-right: 28px;
}

.padding-r-29 {
  padding-right: 29px;
}

.padding-r-30 {
  padding-right: 30px;
}

.padding-r-31 {
  padding-right: 31px;
}

.padding-r-32 {
  padding-right: 32px;
}

.padding-r-33 {
  padding-right: 33px;
}

.padding-r-34 {
  padding-right: 34px;
}

.padding-r-35 {
  padding-right: 35px;
}

.padding-r-36 {
  padding-right: 36px;
}

.padding-r-37 {
  padding-right: 37px;
}

.padding-r-38 {
  padding-right: 38px;
}

.padding-r-39 {
  padding-right: 39px;
}

.padding-r-40 {
  padding-right: 40px;
}

.padding-r-41 {
  padding-right: 41px;
}

.padding-r-42 {
  padding-right: 42px;
}

.padding-r-43 {
  padding-right: 43px;
}

.padding-r-44 {
  padding-right: 44px;
}

.padding-r-45 {
  padding-right: 45px;
}

.padding-r-46 {
  padding-right: 46px;
}

.padding-r-47 {
  padding-right: 47px;
}

.padding-r-48 {
  padding-right: 48px;
}

.padding-r-49 {
  padding-right: 49px;
}

.padding-r-50 {
  padding-right: 50px;
}

.padding-r-51 {
  padding-right: 51px;
}

.padding-r-52 {
  padding-right: 52px;
}

.padding-r-53 {
  padding-right: 53px;
}

.padding-r-54 {
  padding-right: 54px;
}

.padding-r-55 {
  padding-right: 55px;
}

.padding-r-56 {
  padding-right: 56px;
}

.padding-r-57 {
  padding-right: 57px;
}

.padding-r-58 {
  padding-right: 58px;
}

.padding-r-59 {
  padding-right: 59px;
}

.padding-r-60 {
  padding-right: 60px;
}

.padding-r-61 {
  padding-right: 61px;
}

.padding-r-62 {
  padding-right: 62px;
}

.padding-r-63 {
  padding-right: 63px;
}

.padding-r-64 {
  padding-right: 64px;
}

.padding-r-65 {
  padding-right: 65px;
}

.padding-r-66 {
  padding-right: 66px;
}

.padding-r-67 {
  padding-right: 67px;
}

.padding-r-68 {
  padding-right: 68px;
}

.padding-r-69 {
  padding-right: 69px;
}

.padding-r-70 {
  padding-right: 70px;
}

.padding-r-71 {
  padding-right: 71px;
}

.padding-r-72 {
  padding-right: 72px;
}

.padding-r-73 {
  padding-right: 73px;
}

.padding-r-74 {
  padding-right: 74px;
}

.padding-r-75 {
  padding-right: 75px;
}

.padding-r-76 {
  padding-right: 76px;
}

.padding-r-77 {
  padding-right: 77px;
}

.padding-r-78 {
  padding-right: 78px;
}

.padding-r-79 {
  padding-right: 79px;
}

.padding-r-80 {
  padding-right: 80px;
}

.padding-r-81 {
  padding-right: 81px;
}

.padding-r-82 {
  padding-right: 82px;
}

.padding-r-83 {
  padding-right: 83px;
}

.padding-r-84 {
  padding-right: 84px;
}

.padding-r-85 {
  padding-right: 85px;
}

.padding-r-86 {
  padding-right: 86px;
}

.padding-r-87 {
  padding-right: 87px;
}

.padding-r-88 {
  padding-right: 88px;
}

.padding-r-89 {
  padding-right: 89px;
}

.padding-r-90 {
  padding-right: 90px;
}

.padding-r-91 {
  padding-right: 91px;
}

.padding-r-92 {
  padding-right: 92px;
}

.padding-r-93 {
  padding-right: 93px;
}

.padding-r-94 {
  padding-right: 94px;
}

.padding-r-95 {
  padding-right: 95px;
}

.padding-r-96 {
  padding-right: 96px;
}

.padding-r-97 {
  padding-right: 97px;
}

.padding-r-98 {
  padding-right: 98px;
}

.padding-r-99 {
  padding-right: 99px;
}

.padding-r-100 {
  padding-right: 100px;
}

.padding-b-0 {
  padding-bottom: 0px;
}

.padding-b-1 {
  padding-bottom: 1px;
}

.padding-b-2 {
  padding-bottom: 2px;
}

.padding-b-3 {
  padding-bottom: 3px;
}

.padding-b-4 {
  padding-bottom: 4px;
}

.padding-b-5 {
  padding-bottom: 5px;
}

.padding-b-6 {
  padding-bottom: 6px;
}

.padding-b-7 {
  padding-bottom: 7px;
}

.padding-b-8 {
  padding-bottom: 8px;
}

.padding-b-9 {
  padding-bottom: 9px;
}

.padding-b-10 {
  padding-bottom: 10px;
}

.padding-b-11 {
  padding-bottom: 11px;
}

.padding-b-12 {
  padding-bottom: 12px;
}

.padding-b-13 {
  padding-bottom: 13px;
}

.padding-b-14 {
  padding-bottom: 14px;
}

.padding-b-15 {
  padding-bottom: 15px;
}

.padding-b-16 {
  padding-bottom: 16px;
}

.padding-b-17 {
  padding-bottom: 17px;
}

.padding-b-18 {
  padding-bottom: 18px;
}

.padding-b-19 {
  padding-bottom: 19px;
}

.padding-b-20 {
  padding-bottom: 20px;
}

.padding-b-21 {
  padding-bottom: 21px;
}

.padding-b-22 {
  padding-bottom: 22px;
}

.padding-b-23 {
  padding-bottom: 23px;
}

.padding-b-24 {
  padding-bottom: 24px;
}

.padding-b-25 {
  padding-bottom: 25px;
}

.padding-b-26 {
  padding-bottom: 26px;
}

.padding-b-27 {
  padding-bottom: 27px;
}

.padding-b-28 {
  padding-bottom: 28px;
}

.padding-b-29 {
  padding-bottom: 29px;
}

.padding-b-30 {
  padding-bottom: 30px;
}

.padding-b-31 {
  padding-bottom: 31px;
}

.padding-b-32 {
  padding-bottom: 32px;
}

.padding-b-33 {
  padding-bottom: 33px;
}

.padding-b-34 {
  padding-bottom: 34px;
}

.padding-b-35 {
  padding-bottom: 35px;
}

.padding-b-36 {
  padding-bottom: 36px;
}

.padding-b-37 {
  padding-bottom: 37px;
}

.padding-b-38 {
  padding-bottom: 38px;
}

.padding-b-39 {
  padding-bottom: 39px;
}

.padding-b-40 {
  padding-bottom: 40px;
}

.padding-b-41 {
  padding-bottom: 41px;
}

.padding-b-42 {
  padding-bottom: 42px;
}

.padding-b-43 {
  padding-bottom: 43px;
}

.padding-b-44 {
  padding-bottom: 44px;
}

.padding-b-45 {
  padding-bottom: 45px;
}

.padding-b-46 {
  padding-bottom: 46px;
}

.padding-b-47 {
  padding-bottom: 47px;
}

.padding-b-48 {
  padding-bottom: 48px;
}

.padding-b-49 {
  padding-bottom: 49px;
}

.padding-b-50 {
  padding-bottom: 50px;
}

.padding-b-51 {
  padding-bottom: 51px;
}

.padding-b-52 {
  padding-bottom: 52px;
}

.padding-b-53 {
  padding-bottom: 53px;
}

.padding-b-54 {
  padding-bottom: 54px;
}

.padding-b-55 {
  padding-bottom: 55px;
}

.padding-b-56 {
  padding-bottom: 56px;
}

.padding-b-57 {
  padding-bottom: 57px;
}

.padding-b-58 {
  padding-bottom: 58px;
}

.padding-b-59 {
  padding-bottom: 59px;
}

.padding-b-60 {
  padding-bottom: 60px;
}

.padding-b-61 {
  padding-bottom: 61px;
}

.padding-b-62 {
  padding-bottom: 62px;
}

.padding-b-63 {
  padding-bottom: 63px;
}

.padding-b-64 {
  padding-bottom: 64px;
}

.padding-b-65 {
  padding-bottom: 65px;
}

.padding-b-66 {
  padding-bottom: 66px;
}

.padding-b-67 {
  padding-bottom: 67px;
}

.padding-b-68 {
  padding-bottom: 68px;
}

.padding-b-69 {
  padding-bottom: 69px;
}

.padding-b-70 {
  padding-bottom: 70px;
}

.padding-b-71 {
  padding-bottom: 71px;
}

.padding-b-72 {
  padding-bottom: 72px;
}

.padding-b-73 {
  padding-bottom: 73px;
}

.padding-b-74 {
  padding-bottom: 74px;
}

.padding-b-75 {
  padding-bottom: 75px;
}

.padding-b-76 {
  padding-bottom: 76px;
}

.padding-b-77 {
  padding-bottom: 77px;
}

.padding-b-78 {
  padding-bottom: 78px;
}

.padding-b-79 {
  padding-bottom: 79px;
}

.padding-b-80 {
  padding-bottom: 80px;
}

.padding-b-81 {
  padding-bottom: 81px;
}

.padding-b-82 {
  padding-bottom: 82px;
}

.padding-b-83 {
  padding-bottom: 83px;
}

.padding-b-84 {
  padding-bottom: 84px;
}

.padding-b-85 {
  padding-bottom: 85px;
}

.padding-b-86 {
  padding-bottom: 86px;
}

.padding-b-87 {
  padding-bottom: 87px;
}

.padding-b-88 {
  padding-bottom: 88px;
}

.padding-b-89 {
  padding-bottom: 89px;
}

.padding-b-90 {
  padding-bottom: 90px;
}

.padding-b-91 {
  padding-bottom: 91px;
}

.padding-b-92 {
  padding-bottom: 92px;
}

.padding-b-93 {
  padding-bottom: 93px;
}

.padding-b-94 {
  padding-bottom: 94px;
}

.padding-b-95 {
  padding-bottom: 95px;
}

.padding-b-96 {
  padding-bottom: 96px;
}

.padding-b-97 {
  padding-bottom: 97px;
}

.padding-b-98 {
  padding-bottom: 98px;
}

.padding-b-99 {
  padding-bottom: 99px;
}

.padding-b-100 {
  padding-bottom: 100px;
}

.padding-t-0 {
  padding-top: 0px;
}

.padding-t-1 {
  padding-top: 1px;
}

.padding-t-2 {
  padding-top: 2px;
}

.padding-t-3 {
  padding-top: 3px;
}

.padding-t-4 {
  padding-top: 4px;
}

.padding-t-5 {
  padding-top: 5px;
}

.padding-t-6 {
  padding-top: 6px;
}

.padding-t-7 {
  padding-top: 7px;
}

.padding-t-8 {
  padding-top: 8px;
}

.padding-t-9 {
  padding-top: 9px;
}

.padding-t-10 {
  padding-top: 10px;
}

.padding-t-11 {
  padding-top: 11px;
}

.padding-t-12 {
  padding-top: 12px;
}

.padding-t-13 {
  padding-top: 13px;
}

.padding-t-14 {
  padding-top: 14px;
}

.padding-t-15 {
  padding-top: 15px;
}

.padding-t-16 {
  padding-top: 16px;
}

.padding-t-17 {
  padding-top: 17px;
}

.padding-t-18 {
  padding-top: 18px;
}

.padding-t-19 {
  padding-top: 19px;
}

.padding-t-20 {
  padding-top: 20px;
}

.padding-t-21 {
  padding-top: 21px;
}

.padding-t-22 {
  padding-top: 22px;
}

.padding-t-23 {
  padding-top: 23px;
}

.padding-t-24 {
  padding-top: 24px;
}

.padding-t-25 {
  padding-top: 25px;
}

.padding-t-26 {
  padding-top: 26px;
}

.padding-t-27 {
  padding-top: 27px;
}

.padding-t-28 {
  padding-top: 28px;
}

.padding-t-29 {
  padding-top: 29px;
}

.padding-t-30 {
  padding-top: 30px;
}

.padding-t-31 {
  padding-top: 31px;
}

.padding-t-32 {
  padding-top: 32px;
}

.padding-t-33 {
  padding-top: 33px;
}

.padding-t-34 {
  padding-top: 34px;
}

.padding-t-35 {
  padding-top: 35px;
}

.padding-t-36 {
  padding-top: 36px;
}

.padding-t-37 {
  padding-top: 37px;
}

.padding-t-38 {
  padding-top: 38px;
}

.padding-t-39 {
  padding-top: 39px;
}

.padding-t-40 {
  padding-top: 40px;
}

.padding-t-41 {
  padding-top: 41px;
}

.padding-t-42 {
  padding-top: 42px;
}

.padding-t-43 {
  padding-top: 43px;
}

.padding-t-44 {
  padding-top: 44px;
}

.padding-t-45 {
  padding-top: 45px;
}

.padding-t-46 {
  padding-top: 46px;
}

.padding-t-47 {
  padding-top: 47px;
}

.padding-t-48 {
  padding-top: 48px;
}

.padding-t-49 {
  padding-top: 49px;
}

.padding-t-50 {
  padding-top: 50px;
}

.padding-t-51 {
  padding-top: 51px;
}

.padding-t-52 {
  padding-top: 52px;
}

.padding-t-53 {
  padding-top: 53px;
}

.padding-t-54 {
  padding-top: 54px;
}

.padding-t-55 {
  padding-top: 55px;
}

.padding-t-56 {
  padding-top: 56px;
}

.padding-t-57 {
  padding-top: 57px;
}

.padding-t-58 {
  padding-top: 58px;
}

.padding-t-59 {
  padding-top: 59px;
}

.padding-t-60 {
  padding-top: 60px;
}

.padding-t-61 {
  padding-top: 61px;
}

.padding-t-62 {
  padding-top: 62px;
}

.padding-t-63 {
  padding-top: 63px;
}

.padding-t-64 {
  padding-top: 64px;
}

.padding-t-65 {
  padding-top: 65px;
}

.padding-t-66 {
  padding-top: 66px;
}

.padding-t-67 {
  padding-top: 67px;
}

.padding-t-68 {
  padding-top: 68px;
}

.padding-t-69 {
  padding-top: 69px;
}

.padding-t-70 {
  padding-top: 70px;
}

.padding-t-71 {
  padding-top: 71px;
}

.padding-t-72 {
  padding-top: 72px;
}

.padding-t-73 {
  padding-top: 73px;
}

.padding-t-74 {
  padding-top: 74px;
}

.padding-t-75 {
  padding-top: 75px;
}

.padding-t-76 {
  padding-top: 76px;
}

.padding-t-77 {
  padding-top: 77px;
}

.padding-t-78 {
  padding-top: 78px;
}

.padding-t-79 {
  padding-top: 79px;
}

.padding-t-80 {
  padding-top: 80px;
}

.padding-t-81 {
  padding-top: 81px;
}

.padding-t-82 {
  padding-top: 82px;
}

.padding-t-83 {
  padding-top: 83px;
}

.padding-t-84 {
  padding-top: 84px;
}

.padding-t-85 {
  padding-top: 85px;
}

.padding-t-86 {
  padding-top: 86px;
}

.padding-t-87 {
  padding-top: 87px;
}

.padding-t-88 {
  padding-top: 88px;
}

.padding-t-89 {
  padding-top: 89px;
}

.padding-t-90 {
  padding-top: 90px;
}

.padding-t-91 {
  padding-top: 91px;
}

.padding-t-92 {
  padding-top: 92px;
}

.padding-t-93 {
  padding-top: 93px;
}

.padding-t-94 {
  padding-top: 94px;
}

.padding-t-95 {
  padding-top: 95px;
}

.padding-t-96 {
  padding-top: 96px;
}

.padding-t-97 {
  padding-top: 97px;
}

.padding-t-98 {
  padding-top: 98px;
}

.padding-t-99 {
  padding-top: 99px;
}

.padding-t-100 {
  padding-top: 100px;
}

.margin-l-0 {
  margin-left: 0px;
}

.margin-l-1 {
  margin-left: 1px;
}

.margin-l-2 {
  margin-left: 2px;
}

.margin-l-3 {
  margin-left: 3px;
}

.margin-l-4 {
  margin-left: 4px;
}

.margin-l-5 {
  margin-left: 5px;
}

.margin-l-6 {
  margin-left: 6px;
}

.margin-l-7 {
  margin-left: 7px;
}

.margin-l-8 {
  margin-left: 8px;
}

.margin-l-9 {
  margin-left: 9px;
}

.margin-l-10 {
  margin-left: 10px;
}

.margin-l-11 {
  margin-left: 11px;
}

.margin-l-12 {
  margin-left: 12px;
}

.margin-l-13 {
  margin-left: 13px;
}

.margin-l-14 {
  margin-left: 14px;
}

.margin-l-15 {
  margin-left: 15px;
}

.margin-l-16 {
  margin-left: 16px;
}

.margin-l-17 {
  margin-left: 17px;
}

.margin-l-18 {
  margin-left: 18px;
}

.margin-l-19 {
  margin-left: 19px;
}

.margin-l-20 {
  margin-left: 20px;
}

.margin-l-21 {
  margin-left: 21px;
}

.margin-l-22 {
  margin-left: 22px;
}

.margin-l-23 {
  margin-left: 23px;
}

.margin-l-24 {
  margin-left: 24px;
}

.margin-l-25 {
  margin-left: 25px;
}

.margin-l-26 {
  margin-left: 26px;
}

.margin-l-27 {
  margin-left: 27px;
}

.margin-l-28 {
  margin-left: 28px;
}

.margin-l-29 {
  margin-left: 29px;
}

.margin-l-30 {
  margin-left: 30px;
}

.margin-l-31 {
  margin-left: 31px;
}

.margin-l-32 {
  margin-left: 32px;
}

.margin-l-33 {
  margin-left: 33px;
}

.margin-l-34 {
  margin-left: 34px;
}

.margin-l-35 {
  margin-left: 35px;
}

.margin-l-36 {
  margin-left: 36px;
}

.margin-l-37 {
  margin-left: 37px;
}

.margin-l-38 {
  margin-left: 38px;
}

.margin-l-39 {
  margin-left: 39px;
}

.margin-l-40 {
  margin-left: 40px;
}

.margin-l-41 {
  margin-left: 41px;
}

.margin-l-42 {
  margin-left: 42px;
}

.margin-l-43 {
  margin-left: 43px;
}

.margin-l-44 {
  margin-left: 44px;
}

.margin-l-45 {
  margin-left: 45px;
}

.margin-l-46 {
  margin-left: 46px;
}

.margin-l-47 {
  margin-left: 47px;
}

.margin-l-48 {
  margin-left: 48px;
}

.margin-l-49 {
  margin-left: 49px;
}

.margin-l-50 {
  margin-left: 50px;
}

.margin-l-51 {
  margin-left: 51px;
}

.margin-l-52 {
  margin-left: 52px;
}

.margin-l-53 {
  margin-left: 53px;
}

.margin-l-54 {
  margin-left: 54px;
}

.margin-l-55 {
  margin-left: 55px;
}

.margin-l-56 {
  margin-left: 56px;
}

.margin-l-57 {
  margin-left: 57px;
}

.margin-l-58 {
  margin-left: 58px;
}

.margin-l-59 {
  margin-left: 59px;
}

.margin-l-60 {
  margin-left: 60px;
}

.margin-l-61 {
  margin-left: 61px;
}

.margin-l-62 {
  margin-left: 62px;
}

.margin-l-63 {
  margin-left: 63px;
}

.margin-l-64 {
  margin-left: 64px;
}

.margin-l-65 {
  margin-left: 65px;
}

.margin-l-66 {
  margin-left: 66px;
}

.margin-l-67 {
  margin-left: 67px;
}

.margin-l-68 {
  margin-left: 68px;
}

.margin-l-69 {
  margin-left: 69px;
}

.margin-l-70 {
  margin-left: 70px;
}

.margin-l-71 {
  margin-left: 71px;
}

.margin-l-72 {
  margin-left: 72px;
}

.margin-l-73 {
  margin-left: 73px;
}

.margin-l-74 {
  margin-left: 74px;
}

.margin-l-75 {
  margin-left: 75px;
}

.margin-l-76 {
  margin-left: 76px;
}

.margin-l-77 {
  margin-left: 77px;
}

.margin-l-78 {
  margin-left: 78px;
}

.margin-l-79 {
  margin-left: 79px;
}

.margin-l-80 {
  margin-left: 80px;
}

.margin-l-81 {
  margin-left: 81px;
}

.margin-l-82 {
  margin-left: 82px;
}

.margin-l-83 {
  margin-left: 83px;
}

.margin-l-84 {
  margin-left: 84px;
}

.margin-l-85 {
  margin-left: 85px;
}

.margin-l-86 {
  margin-left: 86px;
}

.margin-l-87 {
  margin-left: 87px;
}

.margin-l-88 {
  margin-left: 88px;
}

.margin-l-89 {
  margin-left: 89px;
}

.margin-l-90 {
  margin-left: 90px;
}

.margin-l-91 {
  margin-left: 91px;
}

.margin-l-92 {
  margin-left: 92px;
}

.margin-l-93 {
  margin-left: 93px;
}

.margin-l-94 {
  margin-left: 94px;
}

.margin-l-95 {
  margin-left: 95px;
}

.margin-l-96 {
  margin-left: 96px;
}

.margin-l-97 {
  margin-left: 97px;
}

.margin-l-98 {
  margin-left: 98px;
}

.margin-l-99 {
  margin-left: 99px;
}

.margin-l-100 {
  margin-left: 100px;
}

.margin-r-0 {
  margin-right: 0px;
}

.margin-r-1 {
  margin-right: 1px;
}

.margin-r-2 {
  margin-right: 2px;
}

.margin-r-3 {
  margin-right: 3px;
}

.margin-r-4 {
  margin-right: 4px;
}

.margin-r-5 {
  margin-right: 5px;
}

.margin-r-6 {
  margin-right: 6px;
}

.margin-r-7 {
  margin-right: 7px;
}

.margin-r-8 {
  margin-right: 8px;
}

.margin-r-9 {
  margin-right: 9px;
}

.margin-r-10 {
  margin-right: 10px;
}

.margin-r-11 {
  margin-right: 11px;
}

.margin-r-12 {
  margin-right: 12px;
}

.margin-r-13 {
  margin-right: 13px;
}

.margin-r-14 {
  margin-right: 14px;
}

.margin-r-15 {
  margin-right: 15px;
}

.margin-r-16 {
  margin-right: 16px;
}

.margin-r-17 {
  margin-right: 17px;
}

.margin-r-18 {
  margin-right: 18px;
}

.margin-r-19 {
  margin-right: 19px;
}

.margin-r-20 {
  margin-right: 20px;
}

.margin-r-21 {
  margin-right: 21px;
}

.margin-r-22 {
  margin-right: 22px;
}

.margin-r-23 {
  margin-right: 23px;
}

.margin-r-24 {
  margin-right: 24px;
}

.margin-r-25 {
  margin-right: 25px;
}

.margin-r-26 {
  margin-right: 26px;
}

.margin-r-27 {
  margin-right: 27px;
}

.margin-r-28 {
  margin-right: 28px;
}

.margin-r-29 {
  margin-right: 29px;
}

.margin-r-30 {
  margin-right: 30px;
}

.margin-r-31 {
  margin-right: 31px;
}

.margin-r-32 {
  margin-right: 32px;
}

.margin-r-33 {
  margin-right: 33px;
}

.margin-r-34 {
  margin-right: 34px;
}

.margin-r-35 {
  margin-right: 35px;
}

.margin-r-36 {
  margin-right: 36px;
}

.margin-r-37 {
  margin-right: 37px;
}

.margin-r-38 {
  margin-right: 38px;
}

.margin-r-39 {
  margin-right: 39px;
}

.margin-r-40 {
  margin-right: 40px;
}

.margin-r-41 {
  margin-right: 41px;
}

.margin-r-42 {
  margin-right: 42px;
}

.margin-r-43 {
  margin-right: 43px;
}

.margin-r-44 {
  margin-right: 44px;
}

.margin-r-45 {
  margin-right: 45px;
}

.margin-r-46 {
  margin-right: 46px;
}

.margin-r-47 {
  margin-right: 47px;
}

.margin-r-48 {
  margin-right: 48px;
}

.margin-r-49 {
  margin-right: 49px;
}

.margin-r-50 {
  margin-right: 50px;
}

.margin-r-51 {
  margin-right: 51px;
}

.margin-r-52 {
  margin-right: 52px;
}

.margin-r-53 {
  margin-right: 53px;
}

.margin-r-54 {
  margin-right: 54px;
}

.margin-r-55 {
  margin-right: 55px;
}

.margin-r-56 {
  margin-right: 56px;
}

.margin-r-57 {
  margin-right: 57px;
}

.margin-r-58 {
  margin-right: 58px;
}

.margin-r-59 {
  margin-right: 59px;
}

.margin-r-60 {
  margin-right: 60px;
}

.margin-r-61 {
  margin-right: 61px;
}

.margin-r-62 {
  margin-right: 62px;
}

.margin-r-63 {
  margin-right: 63px;
}

.margin-r-64 {
  margin-right: 64px;
}

.margin-r-65 {
  margin-right: 65px;
}

.margin-r-66 {
  margin-right: 66px;
}

.margin-r-67 {
  margin-right: 67px;
}

.margin-r-68 {
  margin-right: 68px;
}

.margin-r-69 {
  margin-right: 69px;
}

.margin-r-70 {
  margin-right: 70px;
}

.margin-r-71 {
  margin-right: 71px;
}

.margin-r-72 {
  margin-right: 72px;
}

.margin-r-73 {
  margin-right: 73px;
}

.margin-r-74 {
  margin-right: 74px;
}

.margin-r-75 {
  margin-right: 75px;
}

.margin-r-76 {
  margin-right: 76px;
}

.margin-r-77 {
  margin-right: 77px;
}

.margin-r-78 {
  margin-right: 78px;
}

.margin-r-79 {
  margin-right: 79px;
}

.margin-r-80 {
  margin-right: 80px;
}

.margin-r-81 {
  margin-right: 81px;
}

.margin-r-82 {
  margin-right: 82px;
}

.margin-r-83 {
  margin-right: 83px;
}

.margin-r-84 {
  margin-right: 84px;
}

.margin-r-85 {
  margin-right: 85px;
}

.margin-r-86 {
  margin-right: 86px;
}

.margin-r-87 {
  margin-right: 87px;
}

.margin-r-88 {
  margin-right: 88px;
}

.margin-r-89 {
  margin-right: 89px;
}

.margin-r-90 {
  margin-right: 90px;
}

.margin-r-91 {
  margin-right: 91px;
}

.margin-r-92 {
  margin-right: 92px;
}

.margin-r-93 {
  margin-right: 93px;
}

.margin-r-94 {
  margin-right: 94px;
}

.margin-r-95 {
  margin-right: 95px;
}

.margin-r-96 {
  margin-right: 96px;
}

.margin-r-97 {
  margin-right: 97px;
}

.margin-r-98 {
  margin-right: 98px;
}

.margin-r-99 {
  margin-right: 99px;
}

.margin-r-100 {
  margin-right: 100px;
}

.margin-b-0 {
  margin-bottom: 0px;
}

.margin-b-1 {
  margin-bottom: 1px;
}

.margin-b-2 {
  margin-bottom: 2px;
}

.margin-b-3 {
  margin-bottom: 3px;
}

.margin-b-4 {
  margin-bottom: 4px;
}

.margin-b-5 {
  margin-bottom: 5px;
}

.margin-b-6 {
  margin-bottom: 6px;
}

.margin-b-7 {
  margin-bottom: 7px;
}

.margin-b-8 {
  margin-bottom: 8px;
}

.margin-b-9 {
  margin-bottom: 9px;
}

.margin-b-10 {
  margin-bottom: 10px;
}

.margin-b-11 {
  margin-bottom: 11px;
}

.margin-b-12 {
  margin-bottom: 12px;
}

.margin-b-13 {
  margin-bottom: 13px;
}

.margin-b-14 {
  margin-bottom: 14px;
}

.margin-b-15 {
  margin-bottom: 15px;
}

.margin-b-16 {
  margin-bottom: 16px;
}

.margin-b-17 {
  margin-bottom: 17px;
}

.margin-b-18 {
  margin-bottom: 18px;
}

.margin-b-19 {
  margin-bottom: 19px;
}

.margin-b-20 {
  margin-bottom: 20px;
}

.margin-b-21 {
  margin-bottom: 21px;
}

.margin-b-22 {
  margin-bottom: 22px;
}

.margin-b-23 {
  margin-bottom: 23px;
}

.margin-b-24 {
  margin-bottom: 24px;
}

.margin-b-25 {
  margin-bottom: 25px;
}

.margin-b-26 {
  margin-bottom: 26px;
}

.margin-b-27 {
  margin-bottom: 27px;
}

.margin-b-28 {
  margin-bottom: 28px;
}

.margin-b-29 {
  margin-bottom: 29px;
}

.margin-b-30 {
  margin-bottom: 30px;
}

.margin-b-31 {
  margin-bottom: 31px;
}

.margin-b-32 {
  margin-bottom: 32px;
}

.margin-b-33 {
  margin-bottom: 33px;
}

.margin-b-34 {
  margin-bottom: 34px;
}

.margin-b-35 {
  margin-bottom: 35px;
}

.margin-b-36 {
  margin-bottom: 36px;
}

.margin-b-37 {
  margin-bottom: 37px;
}

.margin-b-38 {
  margin-bottom: 38px;
}

.margin-b-39 {
  margin-bottom: 39px;
}

.margin-b-40 {
  margin-bottom: 40px;
}

.margin-b-41 {
  margin-bottom: 41px;
}

.margin-b-42 {
  margin-bottom: 42px;
}

.margin-b-43 {
  margin-bottom: 43px;
}

.margin-b-44 {
  margin-bottom: 44px;
}

.margin-b-45 {
  margin-bottom: 45px;
}

.margin-b-46 {
  margin-bottom: 46px;
}

.margin-b-47 {
  margin-bottom: 47px;
}

.margin-b-48 {
  margin-bottom: 48px;
}

.margin-b-49 {
  margin-bottom: 49px;
}

.margin-b-50 {
  margin-bottom: 50px;
}

.margin-b-51 {
  margin-bottom: 51px;
}

.margin-b-52 {
  margin-bottom: 52px;
}

.margin-b-53 {
  margin-bottom: 53px;
}

.margin-b-54 {
  margin-bottom: 54px;
}

.margin-b-55 {
  margin-bottom: 55px;
}

.margin-b-56 {
  margin-bottom: 56px;
}

.margin-b-57 {
  margin-bottom: 57px;
}

.margin-b-58 {
  margin-bottom: 58px;
}

.margin-b-59 {
  margin-bottom: 59px;
}

.margin-b-60 {
  margin-bottom: 60px;
}

.margin-b-61 {
  margin-bottom: 61px;
}

.margin-b-62 {
  margin-bottom: 62px;
}

.margin-b-63 {
  margin-bottom: 63px;
}

.margin-b-64 {
  margin-bottom: 64px;
}

.margin-b-65 {
  margin-bottom: 65px;
}

.margin-b-66 {
  margin-bottom: 66px;
}

.margin-b-67 {
  margin-bottom: 67px;
}

.margin-b-68 {
  margin-bottom: 68px;
}

.margin-b-69 {
  margin-bottom: 69px;
}

.margin-b-70 {
  margin-bottom: 70px;
}

.margin-b-71 {
  margin-bottom: 71px;
}

.margin-b-72 {
  margin-bottom: 72px;
}

.margin-b-73 {
  margin-bottom: 73px;
}

.margin-b-74 {
  margin-bottom: 74px;
}

.margin-b-75 {
  margin-bottom: 75px;
}

.margin-b-76 {
  margin-bottom: 76px;
}

.margin-b-77 {
  margin-bottom: 77px;
}

.margin-b-78 {
  margin-bottom: 78px;
}

.margin-b-79 {
  margin-bottom: 79px;
}

.margin-b-80 {
  margin-bottom: 80px;
}

.margin-b-81 {
  margin-bottom: 81px;
}

.margin-b-82 {
  margin-bottom: 82px;
}

.margin-b-83 {
  margin-bottom: 83px;
}

.margin-b-84 {
  margin-bottom: 84px;
}

.margin-b-85 {
  margin-bottom: 85px;
}

.margin-b-86 {
  margin-bottom: 86px;
}

.margin-b-87 {
  margin-bottom: 87px;
}

.margin-b-88 {
  margin-bottom: 88px;
}

.margin-b-89 {
  margin-bottom: 89px;
}

.margin-b-90 {
  margin-bottom: 90px;
}

.margin-b-91 {
  margin-bottom: 91px;
}

.margin-b-92 {
  margin-bottom: 92px;
}

.margin-b-93 {
  margin-bottom: 93px;
}

.margin-b-94 {
  margin-bottom: 94px;
}

.margin-b-95 {
  margin-bottom: 95px;
}

.margin-b-96 {
  margin-bottom: 96px;
}

.margin-b-97 {
  margin-bottom: 97px;
}

.margin-b-98 {
  margin-bottom: 98px;
}

.margin-b-99 {
  margin-bottom: 99px;
}

.margin-b-100 {
  margin-bottom: 100px;
}

.margin-t-0 {
  margin-top: 0px;
}

.margin-t-1 {
  margin-top: 1px;
}

.margin-t-2 {
  margin-top: 2px;
}

.margin-t-3 {
  margin-top: 3px;
}

.margin-t-4 {
  margin-top: 4px;
}

.margin-t-5 {
  margin-top: 5px;
}

.margin-t-6 {
  margin-top: 6px;
}

.margin-t-7 {
  margin-top: 7px;
}

.margin-t-8 {
  margin-top: 8px;
}

.margin-t-9 {
  margin-top: 9px;
}

.margin-t-10 {
  margin-top: 10px;
}

.margin-t-11 {
  margin-top: 11px;
}

.margin-t-12 {
  margin-top: 12px;
}

.margin-t-13 {
  margin-top: 13px;
}

.margin-t-14 {
  margin-top: 14px;
}

.margin-t-15 {
  margin-top: 15px;
}

.margin-t-16 {
  margin-top: 16px;
}

.margin-t-17 {
  margin-top: 17px;
}

.margin-t-18 {
  margin-top: 18px;
}

.margin-t-19 {
  margin-top: 19px;
}

.margin-t-20 {
  margin-top: 20px;
}

.margin-t-21 {
  margin-top: 21px;
}

.margin-t-22 {
  margin-top: 22px;
}

.margin-t-23 {
  margin-top: 23px;
}

.margin-t-24 {
  margin-top: 24px;
}

.margin-t-25 {
  margin-top: 25px;
}

.margin-t-26 {
  margin-top: 26px;
}

.margin-t-27 {
  margin-top: 27px;
}

.margin-t-28 {
  margin-top: 28px;
}

.margin-t-29 {
  margin-top: 29px;
}

.margin-t-30 {
  margin-top: 30px;
}

.margin-t-31 {
  margin-top: 31px;
}

.margin-t-32 {
  margin-top: 32px;
}

.margin-t-33 {
  margin-top: 33px;
}

.margin-t-34 {
  margin-top: 34px;
}

.margin-t-35 {
  margin-top: 35px;
}

.margin-t-36 {
  margin-top: 36px;
}

.margin-t-37 {
  margin-top: 37px;
}

.margin-t-38 {
  margin-top: 38px;
}

.margin-t-39 {
  margin-top: 39px;
}

.margin-t-40 {
  margin-top: 40px;
}

.margin-t-41 {
  margin-top: 41px;
}

.margin-t-42 {
  margin-top: 42px;
}

.margin-t-43 {
  margin-top: 43px;
}

.margin-t-44 {
  margin-top: 44px;
}

.margin-t-45 {
  margin-top: 45px;
}

.margin-t-46 {
  margin-top: 46px;
}

.margin-t-47 {
  margin-top: 47px;
}

.margin-t-48 {
  margin-top: 48px;
}

.margin-t-49 {
  margin-top: 49px;
}

.margin-t-50 {
  margin-top: 50px;
}

.margin-t-51 {
  margin-top: 51px;
}

.margin-t-52 {
  margin-top: 52px;
}

.margin-t-53 {
  margin-top: 53px;
}

.margin-t-54 {
  margin-top: 54px;
}

.margin-t-55 {
  margin-top: 55px;
}

.margin-t-56 {
  margin-top: 56px;
}

.margin-t-57 {
  margin-top: 57px;
}

.margin-t-58 {
  margin-top: 58px;
}

.margin-t-59 {
  margin-top: 59px;
}

.margin-t-60 {
  margin-top: 60px;
}

.margin-t-61 {
  margin-top: 61px;
}

.margin-t-62 {
  margin-top: 62px;
}

.margin-t-63 {
  margin-top: 63px;
}

.margin-t-64 {
  margin-top: 64px;
}

.margin-t-65 {
  margin-top: 65px;
}

.margin-t-66 {
  margin-top: 66px;
}

.margin-t-67 {
  margin-top: 67px;
}

.margin-t-68 {
  margin-top: 68px;
}

.margin-t-69 {
  margin-top: 69px;
}

.margin-t-70 {
  margin-top: 70px;
}

.margin-t-71 {
  margin-top: 71px;
}

.margin-t-72 {
  margin-top: 72px;
}

.margin-t-73 {
  margin-top: 73px;
}

.margin-t-74 {
  margin-top: 74px;
}

.margin-t-75 {
  margin-top: 75px;
}

.margin-t-76 {
  margin-top: 76px;
}

.margin-t-77 {
  margin-top: 77px;
}

.margin-t-78 {
  margin-top: 78px;
}

.margin-t-79 {
  margin-top: 79px;
}

.margin-t-80 {
  margin-top: 80px;
}

.margin-t-81 {
  margin-top: 81px;
}

.margin-t-82 {
  margin-top: 82px;
}

.margin-t-83 {
  margin-top: 83px;
}

.margin-t-84 {
  margin-top: 84px;
}

.margin-t-85 {
  margin-top: 85px;
}

.margin-t-86 {
  margin-top: 86px;
}

.margin-t-87 {
  margin-top: 87px;
}

.margin-t-88 {
  margin-top: 88px;
}

.margin-t-89 {
  margin-top: 89px;
}

.margin-t-90 {
  margin-top: 90px;
}

.margin-t-91 {
  margin-top: 91px;
}

.margin-t-92 {
  margin-top: 92px;
}

.margin-t-93 {
  margin-top: 93px;
}

.margin-t-94 {
  margin-top: 94px;
}

.margin-t-95 {
  margin-top: 95px;
}

.margin-t-96 {
  margin-top: 96px;
}

.margin-t-97 {
  margin-top: 97px;
}

.margin-t-98 {
  margin-top: 98px;
}

.margin-t-99 {
  margin-top: 99px;
}

.margin-t-100 {
  margin-top: 100px;
}
@keyframes closeScaleUpFromCenter {
  0% {
    z-index: 4001;
    opacity: 1;
    teansform: scale(1);
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
    z-index: -10;
  }
}
@keyframes openScaleDownFromCenter {
  0% {
    opacity: 0.5;
    teansform: scale(1.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
:root {
  /* Primary colors */
  --primary-color-100: #779BB0;
  --primary-color-300: #454B56;
  --primary-color-400: #294369;
  --primary-color-500: #152935;
  --primary-color-500-50: #2e5c9a80;
  --primary-color-600: #1c1f27;
  --primary-color-650: #1b1e26;
  --primary-color-700: #1a2634;
  --secondary-color-500: #006cff;
  --rs-gray-0: #fff;
  --rs-gray-50: #f7f7fa;
  --rs-gray-100: var(--primary-color-dark-100);
  --rs-gray-200: var(--primary-color-dark-200);
  --rs-gray-300: var(--primary-color-dark-300);
  --rs-gray-400: var(--primary-color-dark-400);
  --rs-gray-500: var(--primary-color-dark-500);
  --rs-gray-600: var(--primary-color-dark-600);
  --rs-gray-700: var(--primary-color-dark-700);
  --rs-gray-800: var(--primary-color-dark-800);
  --rs-gray-900: var(--primary-color-700);
  --rs-primary-50: #f2faff;
  --rs-primary-100: var(--primary-color-dark-100);
  --rs-primary-200: var(--primary-color-dark-200);
  --rs-primary-400: var(--primary-color-400);
  --rs-primary-500: var(--primary-color-500);
  --rs-primary-600: var(--primary-color-600);
  --rs-primary-700: var(--primary-color-700);
  --rs-primary-800: var(--primary-color-dark-800);
  --rs-primary-900: var(--primary-color-dark-900);
  --rs-bg-overlay: var(--primary-color-light-500);
  --rs-calendar-date-selected-text: var(--primary-color-light-500);
  /* Accent colors */
  --accent-color-1: #1B57D1;
  --accent-color-2: #FF832B;
  --accent-color-3: #fe7b06;
  /* Secondary colors */
  --secondary-color-300: #71C187;
  --secondary-color-300-50: #71c18780;
  /* Dark colors */
  --primary-color-dark-900: #000000;
  --primary-color-dark-850: #040D0B;
  --primary-color-dark-800: #152935;
  --primary-color-dark-750: #1C1F27;
  --primary-color-dark-720: #272727;
  --primary-color-dark-700: #353333;
  --primary-color-dark-650: #383c42;
  --primary-color-dark-610: #393b42;
  --primary-color-dark-600: #3F4A50;
  --primary-color-dark-550: #484848;
  --primary-color-dark-500: #535353;
  --primary-color-dark-400: #646464;
  --primary-color-dark-375: #676767;
  --primary-color-dark-350: #736F6F;
  --primary-color-dark-300: #818078;
  --primary-color-dark-200: #AAAAAA;
  --primary-color-dark-100: #BCBCBC;
  /* Light colors */
  --primary-color-light-500: #FFFFFF;
  --primary-color-light-300: #F4F4F4;
  --primary-color-light-200: #F5F5F5;
  --primary-color-light-150: #F6FAFE;
  --primary-color-light-opacity-59: rgba(255, 255, 255, .59);
  --primary-color-light-opacity-45: rgba(255, 255, 255, .45);
  --primary-color-light-opacity-2: rgba(255, 255, 255, .2);
  /* Alert and danger colors */
  --alert-color-1: #DA1E28;
  --alert-color-2: #24A148;
  --alert-color-3: #4a944f;
  --warning-color-1: #f1c755;
  --danger-color-300: #C17D71;
  --danger-color-500: #D7563F;
  /* Brand colors */
  --facebook-brand-color: #1A77F3;
  --linkedin-brand-color: #007DBB;
  --twitter-brand-color: #03A9F4;
  /* Box shadows */
  --box-shadow-primary-5: rgba(0, 0, 0, 0.5);
  --box-shadow-primary-7: rgba(0, 0, 0, 0.07);
  --box-shadow-primary-12: rgba(0, 0, 0, 0.12);
  --box-shadow-primary-13: rgba(0, 0, 0, 0.13);
  --box-shadow-primary-14: rgba(0, 0, 0, 0.14);
  --box-shadow-primary-16: rgba(0, 0, 0, 0.16);
  --box-shadow-primary-18: rgba(0, 0, 0, 0.18);
  --box-shadow-primary-19: rgba(0, 0, 0, 0.19);
  --box-shadow-primary-22: rgba(0, 0, 0, 0.22);
  --box-shadow-primary-25: rgba(0, 0, 0, 0.25);
  --box-shadow-primary-57: rgba(0, 0, 0, 0.57);
  /* Card shadows */
  --card-view-box-shadow: 0 2px 6px 0 rgba(109, 109, 109, 0.08);
  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(109, 109, 109, 0.5);
  --card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);
  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(0, 0, 0, 0.28);
  --z-index-close: -1;
  --z-index-popup: 12;
  --z-index-tooltip: 11;
  --z-index-popup-light: 10;
  --z-index-sticky: 9;
}

/* Dark Theme - Reversed/Adapted Colors */
:root[data-theme=dark] {
  /* Primary colors - Reversed for dark theme */
  --primary-color-100: #BCBCBC; /* Was #779BB0 - now light grey */
  --primary-color-300: #AAAAAA; /* Was #454B56 - now medium grey */
  --primary-color-400: #779BB0; /* Was #294369 - now original 100 */
  --primary-color-500: #FFFFFF; /* Was #152935 - now white for text */
  --primary-color-500-50: rgba(188, 188, 188, 0.5); /* Adapted opacity */
  --primary-color-600: #F4F4F4; /* Was #1c1f27 - now light */
  --primary-color-650: #F5F5F5; /* Was #1b1e26 - now light */
  --primary-color-700: #F6FAFE; /* Was #1a2634 - now lightest */
  /* Mirror rs- (design-system) variables for dark theme so overrides
     in :root are reversed appropriately in dark mode. These reference
     the dark-theme primary/light variables defined above. */
  --rs-gray-0: var(--primary-color-light-500);
  --rs-gray-50: var(--primary-color-light-300);
  --rs-gray-100: var(--primary-color-dark-100);
  --rs-gray-200: var(--primary-color-dark-200);
  --rs-gray-300: var(--primary-color-dark-300);
  --rs-gray-400: var(--primary-color-dark-400);
  --rs-gray-500: var(--primary-color-dark-500);
  --rs-gray-600: var(--primary-color-dark-600);
  --rs-gray-700: var(--primary-color-dark-700);
  --rs-gray-800: var(--primary-color-dark-800);
  --rs-gray-900: var(--primary-color-700);
  --rs-primary-50: var(--primary-color-light-150);
  --rs-primary-100: var(--primary-color-dark-100);
  --rs-primary-200: var(--primary-color-dark-200);
  --rs-primary-400: var(--primary-color-400);
  --rs-primary-500: var(--primary-color-500);
  --rs-primary-600: var(--primary-color-600);
  --rs-primary-700: var(--primary-color-700);
  --rs-primary-800: var(--primary-color-dark-800);
  --rs-primary-900: var(--primary-color-dark-900);
  --rs-bg-overlay: var(--primary-color-light-500);
  --rs-calendar-date-selected-text: var(--primary-color-light-500);
  /* Accent colors - Brightened for dark backgrounds */
  --accent-color-1: #4A7FE7; /* Lightened blue */
  --accent-color-2: #FF9A4D; /* Lightened orange */
  --accent-color-3: #FF8C2B; /* Lightened orange variant */
  --secondary-color-500: #006cff;
  --secondary-color-300: #8FD4A4; /* Lightened green */
  --secondary-color-300-50: rgba(143, 212, 164, 0.5);
  /* Dark colors become background/surface colors */
  --primary-color-dark-900: #FFFFFF; /* Reversed - now white */
  --primary-color-dark-850: #F6FAFE; /* Light background */
  --primary-color-dark-800: #F5F5F5; /* Light surface */
  --primary-color-dark-750: #F4F4F4; /* Light elevated */
  --primary-color-dark-720: #EEEEEE; /* Light hover */
  --primary-color-dark-700: #E8E8E8; /* Light active */
  --primary-color-dark-650: #E0E0E0; /* Light border */
  --primary-color-dark-610: #DDDDDD; /* Light border variant */
  --primary-color-dark-600: #D8D8D8; /* Light subtle */
  --primary-color-dark-550: #CCCCCC; /* Medium light */
  --primary-color-dark-500: #BBBBBB; /* Medium */
  --primary-color-dark-400: #AAAAAA; /* Medium dark */
  --primary-color-dark-375: #999999; /* Medium dark variant */
  --primary-color-dark-350: #888888; /* Dark */
  --primary-color-dark-300: #777777; /* Darker */
  --primary-color-dark-200: #555555; /* Very dark */
  --primary-color-dark-100: #454B56; /* Darkest - original 300 */
  /* Light colors become dark backgrounds */
  --primary-color-light-500: #000000; /* Main dark background */
  --primary-color-light-300: #040D0B; /* Dark secondary */
  --primary-color-light-200: #152935; /* Dark tertiary */
  --primary-color-light-150: #1C1F27; /* Dark elevated */
  --primary-color-light-opacity-59: rgba(0, 0, 0, 0.59);
  --primary-color-light-opacity-45: rgba(0, 0, 0, 0.45);
  --primary-color-light-opacity-2: rgba(0, 0, 0, 0.2);
  /* Alert and danger colors - Enhanced for dark */
  --alert-color-1: #FF4757; /* Brighter red */
  --alert-color-2: #2ECC71; /* Brighter green */
  --alert-color-3: #27AE60; /* Brighter green variant */
  --warning-color-1: #F39C12; /* Brighter yellow */
  --danger-color-300: #E74C3C; /* Brighter danger */
  --danger-color-500: #C0392B; /* Darker danger */
  /* Brand colors - Lightened for dark backgrounds */
  --facebook-brand-color: #4267B2;
  --linkedin-brand-color: #0077B5;
  --twitter-brand-color: #1DA1F2;
  /* Box shadows - Adapted for dark theme */
  --box-shadow-primary-5: rgba(255, 255, 255, 0.1);
  --box-shadow-primary-7: rgba(255, 255, 255, 0.07);
  --box-shadow-primary-12: rgba(255, 255, 255, 0.12);
  --box-shadow-primary-13: rgba(255, 255, 255, 0.13);
  --box-shadow-primary-14: rgba(255, 255, 255, 0.14);
  --box-shadow-primary-16: rgba(255, 255, 255, 0.16);
  --box-shadow-primary-18: rgba(255, 255, 255, 0.18);
  --box-shadow-primary-19: rgba(255, 255, 255, 0.19);
  --box-shadow-primary-22: rgba(255, 255, 255, 0.22);
  --box-shadow-primary-25: rgba(255, 255, 255, 0.25);
  --box-shadow-primary-57: rgba(255, 255, 255, 0.1);
  /* Card shadows - Dark theme */
  --card-view-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.08);
  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(255, 255, 255, 0.15);
  --card-view-box-shadow-light: -1px 1px 8px rgba(255, 255, 255, 0.11);
  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(255, 255, 255, 0.25);
  --z-index-popup: 10;
  --z-index-sticky: 9;
}

.color-primary {
  color: #152935;
}

.color-primary-700 {
  color: #1a2634;
}

.color-primary-dark {
  color: #1B1E26;
}

.color-aqua-green {
  color: #3BCFB2;
}

.color-green {
  color: #29694F;
}

.color-green-dark {
  color: #2A624A;
}

.color-green-light {
  color: #579A6E;
}

.color-purple {
  color: #292F69;
}

.color-red {
  color: #692929;
}

.color-red-light {
  color: #D0021B;
}

.color-orange {
  color: #DD5944;
}

.color-blue {
  color: #294369;
}

.color-blue-grey {
  color: #294369;
}

.color-blue-2 {
  color: #3165B2;
}

.color-yellow {
  color: #19160C;
}

.color-gray {
  color: rgba(141, 141, 141, 0.85);
}

.color-light-green {
  color: #71C187;
}

.color-pink {
  color: #572969;
}

.color-blue-high {
  color: #F6FAFE;
}

.color-blue-2-high {
  color: #F6FAFE;
}

body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  min-height: 100%;
}

html {
  height: 100%;
  margin: 0;
  padding: 0;
}

#root {
  min-height: 100%;
  width: 100%;
}

.display-flex {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
}

.display-inline-flex {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
}

.justify-content-flex-end {
  -moz-justify-content: flex-end;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  justify-content: flex-end;
}

.display--none {
  display: none;
}

.display-flex-center {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}

.display-inline-flex-center, .a-circle-button {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}

.highlight-text, .HIGHLIGHT-TEXT {
  background-color: yellow;
}

.row:before, .row:after {
  display: none !important;
}

.visibility--hidden {
  visibility: hidden;
}
.visibility--visible {
  visibility: visible;
}

.responsive-image {
  width: 100%;
  height: auto;
}

.bg-light {
  background-color: #FFFFFF;
}

.sidenav {
  transition: margin-left 0.3s, max-width 0.3s;
  margin-left: 0px;
  max-width: 100%;
  overflow-x: hidden;
}

.cursor--default {
  cursor: default;
}
.cursor--pointer {
  cursor: pointer;
}

.disable-link {
  pointer-events: none;
}

.position--relative {
  position: relative;
}

.opacity-5 {
  opacity: 0.5;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-1 {
  opacity: 0.01;
}

.font-primary-bold-normal {
  font-family: "Public Sans";
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0;
}

@font-face {
  font-family: "Public Sans";
  font-weight: lighter;
  font-weight: 300;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Thin.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  font-weight: lighter;
  font-weight: 400;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  font-weight: normal;
  font-weight: 500;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  font-weight: normal;
  font-style: italic;
  font-weight: 500;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Italic.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Medium.ttf") format("truetype");
  font-weight: 600;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Bold.ttf") format("truetype");
  font-weight: bold;
  font-weight: 700;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-SemiBold.ttf") format("truetype");
  font-weight: bold;
  font-weight: 800;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Black.ttf") format("truetype");
  font-weight: bold;
  font-weight: 900;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-ExtraBold.ttf") format("truetype");
  font-weight: bold;
  font-weight: 950;
}
@font-face {
  font-family: "Aller";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: lighter;
  font-weight: 300;
}
@font-face {
  font-family: "Aller";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Aller";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: bold;
  font-weight: 700;
}
@keyframes swing-in-top-fwd {
  0% {
    transform: rotateX(-100deg);
    transform-origin: top;
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    transform-origin: top;
    opacity: 1;
  }
}
@keyframes swing-out-top-bck {
  0% {
    transform: rotateX(0deg);
    transform-origin: top;
    opacity: 1;
  }
  100% {
    transform: rotateX(-100deg);
    transform-origin: top;
    opacity: 0;
  }
}
@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
@keyframes slideInFromRight {
  0% {
    transform: translateX(360px);
  }
  100% {
    transform: translateX(0px);
  }
}
@keyframes removeCard {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
    display: none;
  }
}
@keyframes dropdown-zoom-in {
  0% {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
    filter: blur(1px);
  }
  60% {
    opacity: 1;
    transform: translateY(2px) scale(1.03);
    filter: blur(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}
@keyframes dropdown-zoom-out {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
    z-index: -1;
    z-index: var(--z-index-close);
  }
}
.a-button, .a-button[type=submit] {
  padding: 20px 15px;
  border-radius: 4px;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
  display: inline-block;
  -webkit-inline-display: flex;
  -moz-inline-display: flex;
  -ms-inline-display: flex;
  -o-inline-display: flex;
  inline-display: flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  transition: 0.35s;
  font-family: "Public Sans";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
  border: 2px solid transparent;
}
.a-button:hover {
  transition: 0.35s;
}
.a-button[disabled] {
  cursor: default;
  pointer-events: none;
}
.a-button--is-small {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  max-width: none;
  width: auto;
  padding: 15px 20px;
}
.a-button--full-width {
  min-width: 100%;
}
.a-button--primary, .a-button--primary:hover[type=submit], .a-button--primary:visited, .a-button--primary[type=submit] {
  background-color: #152935;
  color: #FFFFFF;
}
.a-button--primary:hover, .a-button--primary[type=submit]:hover {
  background-color: #FFFFFF;
  color: #152935;
  border: 2px solid #152935;
}
.a-button--rounded {
  border-radius: 25px;
}
.a-button__colorable--primary {
  background-color: #FFFFFF;
  color: #152935;
  border: 2px solid #152935;
}
.a-button__colorable--primary:hover {
  color: #FFFFFF;
  background-color: #152935;
  border: 2px solid #152935;
}
.a-button__colorable--secondary {
  background-color: #FFFFFF;
  color: #71C187;
  border: 2px solid #71C187;
}
.a-button__colorable--secondary:hover {
  color: #FFFFFF;
  background-color: #71C187;
  border: 2px solid #71C187;
}

.a-button-link, .a-button-link[type=submit] {
  padding: 5px 10px;
  border-radius: 4px;
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  transition: 0.35s;
  font-family: "Public Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  border: 2px solid transparent;
}
.a-button-link:hover {
  transition: 0.35s;
}
.a-button-link[disabled] {
  cursor: default;
  pointer-events: none;
}
.a-button-link[color=primary-dark] {
  color: #1B1E26;
}
.a-button-link[color=primary-dark]:hover, .a-button-link[color=primary-dark].hold, .a-button-link[color=primary-dark]:focus {
  border: 2px solid transparent;
  background-color: #FFFFFF;
  color: #1B1E26;
  transition: 0.3s;
}
.a-button-link[color=aqua-green] {
  color: #3BCFB2;
}
.a-button-link[color=aqua-green]:hover, .a-button-link[color=aqua-green].hold, .a-button-link[color=aqua-green]:focus {
  border: 2px solid transparent;
  background-color: #E2FFF5;
  color: #3BCFB2;
  transition: 0.3s;
}
.a-button-link[color=green] {
  color: #29694F;
}
.a-button-link[color=green]:hover, .a-button-link[color=green].hold, .a-button-link[color=green]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #29694F;
  transition: 0.3s;
}
.a-button-link[color=green-dark] {
  color: #2A624A;
}
.a-button-link[color=green-dark]:hover, .a-button-link[color=green-dark].hold, .a-button-link[color=green-dark]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #2A624A;
  transition: 0.3s;
}
.a-button-link[color=green-light] {
  color: #579A6E;
}
.a-button-link[color=green-light]:hover, .a-button-link[color=green-light].hold, .a-button-link[color=green-light]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #579A6E;
  transition: 0.3s;
}
.a-button-link[color=purple] {
  color: #292F69;
}
.a-button-link[color=purple]:hover, .a-button-link[color=purple].hold, .a-button-link[color=purple]:focus {
  border: 2px solid transparent;
  background-color: #F6F7FE;
  color: #292F69;
  transition: 0.3s;
}
.a-button-link[color=red] {
  color: #692929;
}
.a-button-link[color=red]:hover, .a-button-link[color=red].hold, .a-button-link[color=red]:focus {
  border: 2px solid transparent;
  background-color: #FEF6F6;
  color: #692929;
  transition: 0.3s;
}
.a-button-link[color=red-light] {
  color: #D0021B;
}
.a-button-link[color=red-light]:hover, .a-button-link[color=red-light].hold, .a-button-link[color=red-light]:focus {
  border: 2px solid transparent;
  background-color: #FEF6F6;
  color: #D0021B;
  transition: 0.3s;
}
.a-button-link[color=orange] {
  color: #DD5944;
}
.a-button-link[color=orange]:hover, .a-button-link[color=orange].hold, .a-button-link[color=orange]:focus {
  border: 2px solid transparent;
  background-color: #FEF6F6;
  color: #DD5944;
  transition: 0.3s;
}
.a-button-link[color=blue] {
  color: #294369;
}
.a-button-link[color=blue]:hover, .a-button-link[color=blue].hold, .a-button-link[color=blue]:focus {
  border: 2px solid transparent;
  background-color: #F6FAFE;
  color: #294369;
  transition: 0.3s;
}
.a-button-link[color=blue-grey] {
  color: #294369;
}
.a-button-link[color=blue-grey]:hover, .a-button-link[color=blue-grey].hold, .a-button-link[color=blue-grey]:focus {
  border: 2px solid transparent;
  background-color: #f5f5f5;
  color: #294369;
  transition: 0.3s;
}
.a-button-link[color=blue-2] {
  color: #3165B2;
}
.a-button-link[color=blue-2]:hover, .a-button-link[color=blue-2].hold, .a-button-link[color=blue-2]:focus {
  border: 2px solid transparent;
  background-color: #F6FAFE;
  color: #3165B2;
  transition: 0.3s;
}
.a-button-link[color=yellow] {
  color: #19160C;
}
.a-button-link[color=yellow]:hover, .a-button-link[color=yellow].hold, .a-button-link[color=yellow]:focus {
  border: 2px solid transparent;
  background-color: #FBFEDC;
  color: #19160C;
  transition: 0.3s;
}
.a-button-link[color=gray] {
  color: rgba(141, 141, 141, 0.85);
}
.a-button-link[color=gray]:hover, .a-button-link[color=gray].hold, .a-button-link[color=gray]:focus {
  border: 2px solid transparent;
  background-color: rgba(241, 241, 241, 0.87);
  color: rgba(141, 141, 141, 0.85);
  transition: 0.3s;
}
.a-button-link[color=light-green] {
  color: #71C187;
}
.a-button-link[color=light-green]:hover, .a-button-link[color=light-green].hold, .a-button-link[color=light-green]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #71C187;
  transition: 0.3s;
}
.a-button-link[color=pink] {
  color: #572969;
}
.a-button-link[color=pink]:hover, .a-button-link[color=pink].hold, .a-button-link[color=pink]:focus {
  border: 2px solid transparent;
  background-color: #FAF6FE;
  color: #572969;
  transition: 0.3s;
}
.a-button-link[color=blue-high] {
  color: #F6FAFE;
}
.a-button-link[color=blue-high]:hover, .a-button-link[color=blue-high].hold, .a-button-link[color=blue-high]:focus {
  border: 2px solid transparent;
  background-color: #294369;
  color: #F6FAFE;
  transition: 0.3s;
}
.a-button-link[color=blue-2-high] {
  color: #F6FAFE;
}
.a-button-link[color=blue-2-high]:hover, .a-button-link[color=blue-2-high].hold, .a-button-link[color=blue-2-high]:focus {
  border: 2px solid transparent;
  background-color: #3165B2;
  color: #F6FAFE;
  transition: 0.3s;
}

.a-circle-button {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0);
  border: 0;
  position: relative;
  text-transform: none;
}
.a-circle-button:not(:last-child) {
  margin-right: 10px;
}
.a-circle-button:hover {
  border: 0;
}
.a-circle-button i {
  color: inherit;
  font-size: inherit;
}
.a-circle-button.small {
  width: 25px;
  height: 25px;
  font-size: 12px;
}
.a-circle-button[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
  min-width: 100%;
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;
  font-family: "Public Sans";
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  padding: 6px 8px;
  border-radius: 6px;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  max-height: 0;
  opacity: 0.9;
  z-index: 100;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
@media screen and (max-width: 1280px) {
  .a-circle-button[data-tooltip]:not([data-tooltip=""]):after {
    left: 0 !important;
    transform: none !important;
  }
}
.a-circle-button[data-tooltip]:not([data-tooltip=""]):before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
  z-index: 101;
}
@media screen and (max-width: 1280px) {
  .a-circle-button[data-tooltip]:not([data-tooltip=""]):before {
    left: 15px !important;
    transform: none !important;
  }
}
.a-circle-button[data-tooltip]:not([data-tooltip=""]):hover:after, .a-circle-button[data-tooltip]:not([data-tooltip=""]):hover:before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}
.a-circle-button[color=primary-dark] {
  background-color: #FFFFFF;
  color: #1B1E26;
}
.a-circle-button[color=primary-dark]:hover {
  color: #FFFFFF;
  background-color: #1B1E26;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=primary-dark-r] {
  background-color: #1B1E26;
  color: #FFFFFF;
}
.a-circle-button[color=primary-dark-r]:hover {
  color: #1B1E26;
  background-color: #FFFFFF;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=aqua-green] {
  background-color: #E2FFF5;
  color: #3BCFB2;
}
.a-circle-button[color=aqua-green]:hover {
  color: #E2FFF5;
  background-color: #3BCFB2;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=aqua-green-r] {
  background-color: #3BCFB2;
  color: #E2FFF5;
}
.a-circle-button[color=aqua-green-r]:hover {
  color: #3BCFB2;
  background-color: #E2FFF5;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green] {
  background-color: #F6FEF9;
  color: #29694F;
}
.a-circle-button[color=green]:hover {
  color: #F6FEF9;
  background-color: #29694F;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-r] {
  background-color: #29694F;
  color: #F6FEF9;
}
.a-circle-button[color=green-r]:hover {
  color: #29694F;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-dark] {
  background-color: #F6FEF9;
  color: #2A624A;
}
.a-circle-button[color=green-dark]:hover {
  color: #F6FEF9;
  background-color: #2A624A;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-dark-r] {
  background-color: #2A624A;
  color: #F6FEF9;
}
.a-circle-button[color=green-dark-r]:hover {
  color: #2A624A;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-light] {
  background-color: #F6FEF9;
  color: #579A6E;
}
.a-circle-button[color=green-light]:hover {
  color: #F6FEF9;
  background-color: #579A6E;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-light-r] {
  background-color: #579A6E;
  color: #F6FEF9;
}
.a-circle-button[color=green-light-r]:hover {
  color: #579A6E;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=purple] {
  background-color: #F6F7FE;
  color: #292F69;
}
.a-circle-button[color=purple]:hover {
  color: #F6F7FE;
  background-color: #292F69;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=purple-r] {
  background-color: #292F69;
  color: #F6F7FE;
}
.a-circle-button[color=purple-r]:hover {
  color: #292F69;
  background-color: #F6F7FE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red] {
  background-color: #FEF6F6;
  color: #692929;
}
.a-circle-button[color=red]:hover {
  color: #FEF6F6;
  background-color: #692929;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red-r] {
  background-color: #692929;
  color: #FEF6F6;
}
.a-circle-button[color=red-r]:hover {
  color: #692929;
  background-color: #FEF6F6;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red-light] {
  background-color: #FEF6F6;
  color: #D0021B;
}
.a-circle-button[color=red-light]:hover {
  color: #FEF6F6;
  background-color: #D0021B;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red-light-r] {
  background-color: #D0021B;
  color: #FEF6F6;
}
.a-circle-button[color=red-light-r]:hover {
  color: #D0021B;
  background-color: #FEF6F6;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=orange] {
  background-color: #FEF6F6;
  color: #DD5944;
}
.a-circle-button[color=orange]:hover {
  color: #FEF6F6;
  background-color: #DD5944;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=orange-r] {
  background-color: #DD5944;
  color: #FEF6F6;
}
.a-circle-button[color=orange-r]:hover {
  color: #DD5944;
  background-color: #FEF6F6;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue] {
  background-color: #F6FAFE;
  color: #294369;
}
.a-circle-button[color=blue]:hover {
  color: #F6FAFE;
  background-color: #294369;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-r] {
  background-color: #294369;
  color: #F6FAFE;
}
.a-circle-button[color=blue-r]:hover {
  color: #294369;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-grey] {
  background-color: #f5f5f5;
  color: #294369;
}
.a-circle-button[color=blue-grey]:hover {
  color: #f5f5f5;
  background-color: #294369;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-grey-r] {
  background-color: #294369;
  color: #f5f5f5;
}
.a-circle-button[color=blue-grey-r]:hover {
  color: #294369;
  background-color: #f5f5f5;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2] {
  background-color: #F6FAFE;
  color: #3165B2;
}
.a-circle-button[color=blue-2]:hover {
  color: #F6FAFE;
  background-color: #3165B2;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2-r] {
  background-color: #3165B2;
  color: #F6FAFE;
}
.a-circle-button[color=blue-2-r]:hover {
  color: #3165B2;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=yellow] {
  background-color: #FBFEDC;
  color: #19160C;
}
.a-circle-button[color=yellow]:hover {
  color: #FBFEDC;
  background-color: #19160C;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=yellow-r] {
  background-color: #19160C;
  color: #FBFEDC;
}
.a-circle-button[color=yellow-r]:hover {
  color: #19160C;
  background-color: #FBFEDC;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=gray] {
  background-color: rgba(241, 241, 241, 0.87);
  color: rgba(141, 141, 141, 0.85);
}
.a-circle-button[color=gray]:hover {
  color: rgba(241, 241, 241, 0.87);
  background-color: rgba(141, 141, 141, 0.85);
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=gray-r] {
  background-color: rgba(141, 141, 141, 0.85);
  color: rgba(241, 241, 241, 0.87);
}
.a-circle-button[color=gray-r]:hover {
  color: rgba(141, 141, 141, 0.85);
  background-color: rgba(241, 241, 241, 0.87);
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=light-green] {
  background-color: #F6FEF9;
  color: #71C187;
}
.a-circle-button[color=light-green]:hover {
  color: #F6FEF9;
  background-color: #71C187;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=light-green-r] {
  background-color: #71C187;
  color: #F6FEF9;
}
.a-circle-button[color=light-green-r]:hover {
  color: #71C187;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=pink] {
  background-color: #FAF6FE;
  color: #572969;
}
.a-circle-button[color=pink]:hover {
  color: #FAF6FE;
  background-color: #572969;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=pink-r] {
  background-color: #572969;
  color: #FAF6FE;
}
.a-circle-button[color=pink-r]:hover {
  color: #572969;
  background-color: #FAF6FE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-high] {
  background-color: #294369;
  color: #F6FAFE;
}
.a-circle-button[color=blue-high]:hover {
  color: #294369;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-high-r] {
  background-color: #F6FAFE;
  color: #294369;
}
.a-circle-button[color=blue-high-r]:hover {
  color: #F6FAFE;
  background-color: #294369;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2-high] {
  background-color: #3165B2;
  color: #F6FAFE;
}
.a-circle-button[color=blue-2-high]:hover {
  color: #3165B2;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2-high-r] {
  background-color: #F6FAFE;
  color: #3165B2;
}
.a-circle-button[color=blue-2-high-r]:hover {
  color: #F6FAFE;
  background-color: #3165B2;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}

.a-link {
  color: #646464;
  font-family: "Public Sans";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 17px;
  border: none;
}
.a-link--underline {
  text-decoration: underline;
}
.a-link:hover {
  border: none;
  color: #353333;
}
.a-link--display-block {
  -webkit-display: block;
  -moz-display: block;
  -ms-display: block;
  -o-display: block;
  display: block;
}

a[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
  min-width: 100%;
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;
  font-family: "Public Sans";
  padding: 10px 10px;
  border-radius: 6px;
  top: calc(100% + 10px);
  max-height: 0;
  opacity: 0.8;
  z-index: 1;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
a[data-tooltip]:not([data-tooltip=""]):before {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  visibility: hidden;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
}
a[data-tooltip]:not([data-tooltip=""]):hover:after, a[data-tooltip]:not([data-tooltip=""]):hover:before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}

.a-hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: #646464;
  text-align: center;
  height: 1.5em;
  opacity: 0.5;
}
.a-hr-text:before {
  content: "";
  background: linear-gradient(to right, transparent, #646464, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.a-hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: #646464;
  font-family: "Public Sans";
  font-size: 15px;
  letter-spacing: 0;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: #818078;
}
.a-hr-text[data-color=light]:after {
  background-color: #FFFFFF;
}
.a-hr-text[data-color=light-300]:after {
  background-color: #F4F4F4;
}

.a-tooltip {
  position: relative;
  display: inline-block;
  margin-top: 0;
  max-height: 24px;
}
.a-tooltip.inline-flex {
  display: inline-flex;
}
.a-tooltip:hover .a-tooltip__content {
  z-index: 20;
  visibility: visible;
  opacity: 1;
  transform: scale(1) translateX(-50%);
  transition: opacity .3s ease-in-out, transform .2s, top .25s, max-width .4s;
}
.a-tooltip.right .a-tooltip__content {
  top: 50%;
  transform: translateY(-50%);
  left: 150%;
}
.a-tooltip.right .a-tooltip__content:after {
  top: calc(50% - 10px);
  left: -15px;
  margin-left: -5px;
  transform: rotate(90deg);
}
.a-tooltip__content {
  border-radius: 20px;
  visibility: hidden;
  min-width: 360px;
  max-width: 600px;
  height: auto;
  border-radius: 20px;
  background-color: #FFFFFF;
  box-shadow: 1px 2px 8px 3px rgba(0, 0, 0, 0.19);
  position: absolute;
  z-index: -1;
  padding: 15px 15px;
  margin-top: 10px;
  text-align: left;
  opacity: 0;
  transform: scale(0.7);
  transition: opacity .25s ease-in-out, transform .6s, top .7s, z-index .1s 1s, max-width .4s;
  /* Position the tooltip text */
  position: absolute;
  top: 140%;
  left: 0;
  transform: translateX(-50%);
}
@media (min-width: 992px) {
  .a-tooltip__content {
    min-width: 460px;
  }
}
.a-tooltip__content__title {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  color: #484848;
  font-family: "Public Sans";
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.2;
  margin-top: 0;
  text-transform: none;
  text-transform: initial;
}
.a-tooltip__content__text {
  font-family: "Helvetica Neue";
  color: #484848;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.35;
  margin-top: 10px;
  text-transform: none;
  text-transform: initial;
}
.a-tooltip__content:after {
  content: "";
  width: 4px;
  height: 10px;
  box-shadow: -1px 0px 10px -5px rgba(0, 0, 0, 0.07);
  position: absolute;
  top: -18px;
  left: 50%;
  border-width: 10px;
  border-style: solid;
  border-color: #FFFFFF transparent transparent transparent;
  transform: rotate(180deg);
  background-color: transparent;
}

.heatmap-view * + * {
  margin-top: 0;
}
.heatmap-view__sources {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -o-flex-flow: row;
  flex-flow: row;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: flex-end;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.heatmap-view__sources__item {
  border: 1px solid #152935;
  border-radius: 20px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  color: #152935;
  border: 1px solid #152935;
  font-family: "Public Sans";
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 15px;
  padding: 5px 15px;
  margin-top: 0;
  cursor: pointer;
  margin-left: 10px;
}
@media (min-width: 992px) {
  .heatmap-view__sources__item {
    font-size: 11px;
    font-weight: 500;
    padding: 7px 20px;
  }
}
.heatmap-view__sources__item[disabled] {
  cursor: default;
  pointer-events: none;
  opacity: 0.6;
  background-color: #BCBCBC;
}
.heatmap-view__sources__item.selected {
  color: #FFFFFF;
  border: 1px solid #152935;
  border-radius: 20px;
  background-color: #152935;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.heatmap-tooltip {
  width: 375px;
  height: auto;
  color: #484848;
  font-family: "Public Sans";
}
.heatmap-tooltip__title {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.4px;
  line-height: 1.2;
  text-transform: uppercase;
}
.heatmap-tooltip ul {
  list-style: none;
  -webkit-display: grid;
  -moz-display: grid;
  -ms-display: grid;
  -o-display: grid;
  display: grid;
  -webkit-grid-template-columns: 1fr 1fr 1fr;
  -moz-grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-template-columns: 1fr 1fr 1fr;
  -o-grid-template-columns: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  -webkit-grid-template-rows: auto;
  -moz-grid-template-rows: auto;
  -ms-grid-template-rows: auto;
  -o-grid-template-rows: auto;
  grid-template-rows: auto;
}
.heatmap-tooltip ul li {
  margin-top: 10px;
  -webkit-display: grid;
  -moz-display: grid;
  -ms-display: grid;
  -o-display: grid;
  display: grid;
  -webkit-grid-template-columns: 15px 2fr 1fr;
  -moz-grid-template-columns: 15px 2fr 1fr;
  -ms-grid-template-columns: 15px 2fr 1fr;
  -o-grid-template-columns: 15px 2fr 1fr;
  grid-template-columns: 15px 2fr 1fr;
  -webkit-grid-template-rows: 1;
  -moz-grid-template-rows: 1;
  -ms-grid-template-rows: 1;
  -o-grid-template-rows: 1;
  grid-template-rows: 1;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.heatmap-tooltip ul li.sort {
  -webkit-grid-template-columns: 15px 45px auto;
  -moz-grid-template-columns: 15px 45px auto;
  -ms-grid-template-columns: 15px 45px auto;
  -o-grid-template-columns: 15px 45px auto;
  grid-template-columns: 15px 45px auto;
}
.heatmap-tooltip ul li:before {
  display: none;
  content: "";
}
.heatmap-tooltip h5 {
  margin-top: 15px;
  font-weight: bold;
}
.heatmap-tooltip p {
  word-wrap: break-word;
  width: 100%;
  white-space: normal;
  word-break: break-word;
  font-size: 14px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixins.scss","webpack://./src/components/User/Reports/HeatmapView/HeatmapView.scss","webpack://./src/scss/_colors.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_commons.scss","webpack://./src/scss/_fonts.scss","webpack://./src/scss/_animations.scss","webpack://./src/scss/atoms/buttons.scss","webpack://./src/scss/atoms/button-link.scss","webpack://./src/scss/atoms/circle-button.scss","webpack://./src/scss/atoms/link.scss","webpack://./src/scss/atoms/hr.scss","webpack://./src/scss/atoms/tooltip.scss"],"names":[],"mappings":"AAsII;EACE,iBAAA;ACpIN;;ADmII;EACE,iBAAA;AChIN;;AD+HI;EACE,iBAAA;AC5HN;;AD2HI;EACE,iBAAA;ACxHN;;ADuHI;EACE,iBAAA;ACpHN;;ADmHI;EACE,iBAAA;AChHN;;AD+GI;EACE,iBAAA;AC5GN;;AD2GI;EACE,iBAAA;ACxGN;;ADuGI;EACE,iBAAA;ACpGN;;ADmGI;EACE,iBAAA;AChGN;;AD+FI;EACE,kBAAA;AC5FN;;AD2FI;EACE,kBAAA;ACxFN;;ADuFI;EACE,kBAAA;ACpFN;;ADmFI;EACE,kBAAA;AChFN;;AD+EI;EACE,kBAAA;AC5EN;;AD2EI;EACE,kBAAA;ACxEN;;ADuEI;EACE,kBAAA;ACpEN;;ADmEI;EACE,kBAAA;AChEN;;AD+DI;EACE,kBAAA;AC5DN;;AD2DI;EACE,kBAAA;ACxDN;;ADuDI;EACE,kBAAA;ACpDN;;ADmDI;EACE,kBAAA;AChDN;;AD+CI;EACE,kBAAA;AC5CN;;AD2CI;EACE,kBAAA;ACxCN;;ADuCI;EACE,kBAAA;ACpCN;;ADmCI;EACE,kBAAA;AChCN;;AD+BI;EACE,kBAAA;AC5BN;;AD2BI;EACE,kBAAA;ACxBN;;ADuBI;EACE,kBAAA;ACpBN;;ADmBI;EACE,kBAAA;AChBN;;ADeI;EACE,kBAAA;ACZN;;ADWI;EACE,kBAAA;ACRN;;ADOI;EACE,kBAAA;ACJN;;ADGI;EACE,kBAAA;ACAN;;ADDI;EACE,kBAAA;ACIN;;ADLI;EACE,kBAAA;ACQN;;ADTI;EACE,kBAAA;ACYN;;ADbI;EACE,kBAAA;ACgBN;;ADjBI;EACE,kBAAA;ACoBN;;ADrBI;EACE,kBAAA;ACwBN;;ADzBI;EACE,kBAAA;AC4BN;;AD7BI;EACE,kBAAA;ACgCN;;ADjCI;EACE,kBAAA;ACoCN;;ADrCI;EACE,kBAAA;ACwCN;;ADzCI;EACE,kBAAA;AC4CN;;AD7CI;EACE,kBAAA;ACgDN;;ADjDI;EACE,kBAAA;ACoDN;;ADrDI;EACE,kBAAA;ACwDN;;ADzDI;EACE,kBAAA;AC4DN;;AD7DI;EACE,kBAAA;ACgEN;;ADjEI;EACE,kBAAA;ACoEN;;ADrEI;EACE,kBAAA;ACwEN;;ADzEI;EACE,kBAAA;AC4EN;;AD7EI;EACE,kBAAA;ACgFN;;ADjFI;EACE,kBAAA;ACoFN;;ADrFI;EACE,kBAAA;ACwFN;;ADzFI;EACE,kBAAA;AC4FN;;AD7FI;EACE,kBAAA;ACgGN;;ADjGI;EACE,kBAAA;ACoGN;;ADrGI;EACE,kBAAA;ACwGN;;ADzGI;EACE,kBAAA;AC4GN;;AD7GI;EACE,kBAAA;ACgHN;;ADjHI;EACE,kBAAA;ACoHN;;ADrHI;EACE,kBAAA;ACwHN;;ADzHI;EACE,kBAAA;AC4HN;;AD7HI;EACE,kBAAA;ACgIN;;ADjII;EACE,kBAAA;ACoIN;;ADrII;EACE,kBAAA;ACwIN;;ADzII;EACE,kBAAA;AC4IN;;AD7II;EACE,kBAAA;ACgJN;;ADjJI;EACE,kBAAA;ACoJN;;ADrJI;EACE,kBAAA;ACwJN;;ADzJI;EACE,kBAAA;AC4JN;;AD7JI;EACE,kBAAA;ACgKN;;ADjKI;EACE,kBAAA;ACoKN;;ADrKI;EACE,kBAAA;ACwKN;;ADzKI;EACE,kBAAA;AC4KN;;AD7KI;EACE,kBAAA;ACgLN;;ADjLI;EACE,kBAAA;ACoLN;;ADrLI;EACE,kBAAA;ACwLN;;ADzLI;EACE,kBAAA;AC4LN;;AD7LI;EACE,kBAAA;ACgMN;;ADjMI;EACE,kBAAA;ACoMN;;ADrMI;EACE,kBAAA;ACwMN;;ADzMI;EACE,kBAAA;AC4MN;;AD7MI;EACE,kBAAA;ACgNN;;ADjNI;EACE,kBAAA;ACoNN;;ADrNI;EACE,kBAAA;ACwNN;;ADzNI;EACE,kBAAA;AC4NN;;AD7NI;EACE,kBAAA;ACgON;;ADjOI;EACE,kBAAA;ACoON;;ADrOI;EACE,kBAAA;ACwON;;ADzOI;EACE,kBAAA;AC4ON;;AD7OI;EACE,kBAAA;ACgPN;;ADjPI;EACE,kBAAA;ACoPN;;ADrPI;EACE,kBAAA;ACwPN;;ADzPI;EACE,kBAAA;AC4PN;;AD7PI;EACE,kBAAA;ACgQN;;ADjQI;EACE,kBAAA;ACoQN;;ADrQI;EACE,kBAAA;ACwQN;;ADzQI;EACE,mBAAA;AC4QN;;AD7QI;EACE,kBAAA;ACgRN;;ADjRI;EACE,kBAAA;ACoRN;;ADrRI;EACE,kBAAA;ACwRN;;ADzRI;EACE,kBAAA;AC4RN;;AD7RI;EACE,kBAAA;ACgSN;;ADjSI;EACE,kBAAA;ACoSN;;ADrSI;EACE,kBAAA;ACwSN;;ADzSI;EACE,kBAAA;AC4SN;;AD7SI;EACE,kBAAA;ACgTN;;ADjTI;EACE,kBAAA;ACoTN;;ADrTI;EACE,mBAAA;ACwTN;;ADzTI;EACE,mBAAA;AC4TN;;AD7TI;EACE,mBAAA;ACgUN;;ADjUI;EACE,mBAAA;ACoUN;;ADrUI;EACE,mBAAA;ACwUN;;ADzUI;EACE,mBAAA;AC4UN;;AD7UI;EACE,mBAAA;ACgVN;;ADjVI;EACE,mBAAA;ACoVN;;ADrVI;EACE,mBAAA;ACwVN;;ADzVI;EACE,mBAAA;AC4VN;;AD7VI;EACE,mBAAA;ACgWN;;ADjWI;EACE,mBAAA;ACoWN;;ADrWI;EACE,mBAAA;ACwWN;;ADzWI;EACE,mBAAA;AC4WN;;AD7WI;EACE,mBAAA;ACgXN;;ADjXI;EACE,mBAAA;ACoXN;;ADrXI;EACE,mBAAA;ACwXN;;ADzXI;EACE,mBAAA;AC4XN;;AD7XI;EACE,mBAAA;ACgYN;;ADjYI;EACE,mBAAA;ACoYN;;ADrYI;EACE,mBAAA;ACwYN;;ADzYI;EACE,mBAAA;AC4YN;;AD7YI;EACE,mBAAA;ACgZN;;ADjZI;EACE,mBAAA;ACoZN;;ADrZI;EACE,mBAAA;ACwZN;;ADzZI;EACE,mBAAA;AC4ZN;;AD7ZI;EACE,mBAAA;ACgaN;;ADjaI;EACE,mBAAA;ACoaN;;ADraI;EACE,mBAAA;ACwaN;;ADzaI;EACE,mBAAA;AC4aN;;AD7aI;EACE,mBAAA;ACgbN;;ADjbI;EACE,mBAAA;ACobN;;ADrbI;EACE,mBAAA;ACwbN;;ADzbI;EACE,mBAAA;AC4bN;;AD7bI;EACE,mBAAA;ACgcN;;ADjcI;EACE,mBAAA;ACocN;;ADrcI;EACE,mBAAA;ACwcN;;ADzcI;EACE,mBAAA;AC4cN;;AD7cI;EACE,mBAAA;ACgdN;;ADjdI;EACE,mBAAA;ACodN;;ADrdI;EACE,mBAAA;ACwdN;;ADzdI;EACE,mBAAA;AC4dN;;AD7dI;EACE,mBAAA;ACgeN;;ADjeI;EACE,mBAAA;ACoeN;;ADreI;EACE,mBAAA;ACweN;;ADzeI;EACE,mBAAA;AC4eN;;AD7eI;EACE,mBAAA;ACgfN;;ADjfI;EACE,mBAAA;ACofN;;ADrfI;EACE,mBAAA;ACwfN;;ADzfI;EACE,mBAAA;AC4fN;;AD7fI;EACE,mBAAA;ACggBN;;ADjgBI;EACE,mBAAA;ACogBN;;ADrgBI;EACE,mBAAA;ACwgBN;;ADzgBI;EACE,mBAAA;AC4gBN;;AD7gBI;EACE,mBAAA;ACghBN;;ADjhBI;EACE,mBAAA;ACohBN;;ADrhBI;EACE,mBAAA;ACwhBN;;ADzhBI;EACE,mBAAA;AC4hBN;;AD7hBI;EACE,mBAAA;ACgiBN;;ADjiBI;EACE,mBAAA;ACoiBN;;ADriBI;EACE,mBAAA;ACwiBN;;ADziBI;EACE,mBAAA;AC4iBN;;AD7iBI;EACE,mBAAA;ACgjBN;;ADjjBI;EACE,mBAAA;ACojBN;;ADrjBI;EACE,mBAAA;ACwjBN;;ADzjBI;EACE,mBAAA;AC4jBN;;AD7jBI;EACE,mBAAA;ACgkBN;;ADjkBI;EACE,mBAAA;ACokBN;;ADrkBI;EACE,mBAAA;ACwkBN;;ADzkBI;EACE,mBAAA;AC4kBN;;AD7kBI;EACE,mBAAA;ACglBN;;ADjlBI;EACE,mBAAA;AColBN;;ADrlBI;EACE,mBAAA;ACwlBN;;ADzlBI;EACE,mBAAA;AC4lBN;;AD7lBI;EACE,mBAAA;ACgmBN;;ADjmBI;EACE,mBAAA;AComBN;;ADrmBI;EACE,mBAAA;ACwmBN;;ADzmBI;EACE,mBAAA;AC4mBN;;AD7mBI;EACE,mBAAA;ACgnBN;;ADjnBI;EACE,mBAAA;AConBN;;ADrnBI;EACE,mBAAA;ACwnBN;;ADznBI;EACE,mBAAA;AC4nBN;;AD7nBI;EACE,mBAAA;ACgoBN;;ADjoBI;EACE,mBAAA;ACooBN;;ADroBI;EACE,mBAAA;ACwoBN;;ADzoBI;EACE,mBAAA;AC4oBN;;AD7oBI;EACE,mBAAA;ACgpBN;;ADjpBI;EACE,mBAAA;ACopBN;;ADrpBI;EACE,mBAAA;ACwpBN;;ADzpBI;EACE,mBAAA;AC4pBN;;AD7pBI;EACE,oBAAA;ACgqBN;;ADjqBI;EACE,mBAAA;ACoqBN;;ADrqBI;EACE,mBAAA;ACwqBN;;ADzqBI;EACE,mBAAA;AC4qBN;;AD7qBI;EACE,mBAAA;ACgrBN;;ADjrBI;EACE,mBAAA;ACorBN;;ADrrBI;EACE,mBAAA;ACwrBN;;ADzrBI;EACE,mBAAA;AC4rBN;;AD7rBI;EACE,mBAAA;ACgsBN;;ADjsBI;EACE,mBAAA;ACosBN;;ADrsBI;EACE,mBAAA;ACwsBN;;ADzsBI;EACE,oBAAA;AC4sBN;;AD7sBI;EACE,oBAAA;ACgtBN;;ADjtBI;EACE,oBAAA;ACotBN;;ADrtBI;EACE,oBAAA;ACwtBN;;ADztBI;EACE,oBAAA;AC4tBN;;AD7tBI;EACE,oBAAA;ACguBN;;ADjuBI;EACE,oBAAA;ACouBN;;ADruBI;EACE,oBAAA;ACwuBN;;ADzuBI;EACE,oBAAA;AC4uBN;;AD7uBI;EACE,oBAAA;ACgvBN;;ADjvBI;EACE,oBAAA;ACovBN;;ADrvBI;EACE,oBAAA;ACwvBN;;ADzvBI;EACE,oBAAA;AC4vBN;;AD7vBI;EACE,oBAAA;ACgwBN;;ADjwBI;EACE,oBAAA;ACowBN;;ADrwBI;EACE,oBAAA;ACwwBN;;ADzwBI;EACE,oBAAA;AC4wBN;;AD7wBI;EACE,oBAAA;ACgxBN;;ADjxBI;EACE,oBAAA;ACoxBN;;ADrxBI;EACE,oBAAA;ACwxBN;;ADzxBI;EACE,oBAAA;AC4xBN;;AD7xBI;EACE,oBAAA;ACgyBN;;ADjyBI;EACE,oBAAA;ACoyBN;;ADryBI;EACE,oBAAA;ACwyBN;;ADzyBI;EACE,oBAAA;AC4yBN;;AD7yBI;EACE,oBAAA;ACgzBN;;ADjzBI;EACE,oBAAA;ACozBN;;ADrzBI;EACE,oBAAA;ACwzBN;;ADzzBI;EACE,oBAAA;AC4zBN;;AD7zBI;EACE,oBAAA;ACg0BN;;ADj0BI;EACE,oBAAA;ACo0BN;;ADr0BI;EACE,oBAAA;ACw0BN;;ADz0BI;EACE,oBAAA;AC40BN;;AD70BI;EACE,oBAAA;ACg1BN;;ADj1BI;EACE,oBAAA;ACo1BN;;ADr1BI;EACE,oBAAA;ACw1BN;;ADz1BI;EACE,oBAAA;AC41BN;;AD71BI;EACE,oBAAA;ACg2BN;;ADj2BI;EACE,oBAAA;ACo2BN;;ADr2BI;EACE,oBAAA;ACw2BN;;ADz2BI;EACE,oBAAA;AC42BN;;AD72BI;EACE,oBAAA;ACg3BN;;ADj3BI;EACE,oBAAA;ACo3BN;;ADr3BI;EACE,oBAAA;ACw3BN;;ADz3BI;EACE,oBAAA;AC43BN;;AD73BI;EACE,oBAAA;ACg4BN;;ADj4BI;EACE,oBAAA;ACo4BN;;ADr4BI;EACE,oBAAA;ACw4BN;;ADz4BI;EACE,oBAAA;AC44BN;;AD74BI;EACE,oBAAA;ACg5BN;;ADj5BI;EACE,oBAAA;ACo5BN;;ADr5BI;EACE,oBAAA;ACw5BN;;ADz5BI;EACE,oBAAA;AC45BN;;AD75BI;EACE,oBAAA;ACg6BN;;ADj6BI;EACE,oBAAA;ACo6BN;;ADr6BI;EACE,oBAAA;ACw6BN;;ADz6BI;EACE,oBAAA;AC46BN;;AD76BI;EACE,oBAAA;ACg7BN;;ADj7BI;EACE,oBAAA;ACo7BN;;ADr7BI;EACE,oBAAA;ACw7BN;;ADz7BI;EACE,oBAAA;AC47BN;;AD77BI;EACE,oBAAA;ACg8BN;;ADj8BI;EACE,oBAAA;ACo8BN;;ADr8BI;EACE,oBAAA;ACw8BN;;ADz8BI;EACE,oBAAA;AC48BN;;AD78BI;EACE,oBAAA;ACg9BN;;ADj9BI;EACE,oBAAA;ACo9BN;;ADr9BI;EACE,oBAAA;ACw9BN;;ADz9BI;EACE,oBAAA;AC49BN;;AD79BI;EACE,oBAAA;ACg+BN;;ADj+BI;EACE,oBAAA;ACo+BN;;ADr+BI;EACE,oBAAA;ACw+BN;;ADz+BI;EACE,oBAAA;AC4+BN;;AD7+BI;EACE,oBAAA;ACg/BN;;ADj/BI;EACE,oBAAA;ACo/BN;;ADr/BI;EACE,oBAAA;ACw/BN;;ADz/BI;EACE,oBAAA;AC4/BN;;AD7/BI;EACE,oBAAA;ACggCN;;ADjgCI;EACE,oBAAA;ACogCN;;ADrgCI;EACE,oBAAA;ACwgCN;;ADzgCI;EACE,oBAAA;AC4gCN;;AD7gCI;EACE,oBAAA;ACghCN;;ADjhCI;EACE,oBAAA;ACohCN;;ADrhCI;EACE,oBAAA;ACwhCN;;ADzhCI;EACE,oBAAA;AC4hCN;;AD7hCI;EACE,oBAAA;ACgiCN;;ADjiCI;EACE,oBAAA;ACoiCN;;ADriCI;EACE,oBAAA;ACwiCN;;ADziCI;EACE,oBAAA;AC4iCN;;AD7iCI;EACE,oBAAA;ACgjCN;;ADjjCI;EACE,qBAAA;ACojCN;;ADrjCI;EACE,gBAAA;ACwjCN;;ADzjCI;EACE,gBAAA;AC4jCN;;AD7jCI;EACE,gBAAA;ACgkCN;;ADjkCI;EACE,gBAAA;ACokCN;;ADrkCI;EACE,gBAAA;ACwkCN;;ADzkCI;EACE,gBAAA;AC4kCN;;AD7kCI;EACE,gBAAA;ACglCN;;ADjlCI;EACE,gBAAA;AColCN;;ADrlCI;EACE,gBAAA;ACwlCN;;ADzlCI;EACE,gBAAA;AC4lCN;;AD7lCI;EACE,iBAAA;ACgmCN;;ADjmCI;EACE,iBAAA;AComCN;;ADrmCI;EACE,iBAAA;ACwmCN;;ADzmCI;EACE,iBAAA;AC4mCN;;AD7mCI;EACE,iBAAA;ACgnCN;;ADjnCI;EACE,iBAAA;AConCN;;ADrnCI;EACE,iBAAA;ACwnCN;;ADznCI;EACE,iBAAA;AC4nCN;;AD7nCI;EACE,iBAAA;ACgoCN;;ADjoCI;EACE,iBAAA;ACooCN;;ADroCI;EACE,iBAAA;ACwoCN;;ADzoCI;EACE,iBAAA;AC4oCN;;AD7oCI;EACE,iBAAA;ACgpCN;;ADjpCI;EACE,iBAAA;ACopCN;;ADrpCI;EACE,iBAAA;ACwpCN;;ADzpCI;EACE,iBAAA;AC4pCN;;AD7pCI;EACE,iBAAA;ACgqCN;;ADjqCI;EACE,iBAAA;ACoqCN;;ADrqCI;EACE,iBAAA;ACwqCN;;ADzqCI;EACE,iBAAA;AC4qCN;;AD7qCI;EACE,iBAAA;ACgrCN;;ADjrCI;EACE,iBAAA;ACorCN;;ADrrCI;EACE,iBAAA;ACwrCN;;ADzrCI;EACE,iBAAA;AC4rCN;;AD7rCI;EACE,iBAAA;ACgsCN;;ADjsCI;EACE,iBAAA;ACosCN;;ADrsCI;EACE,iBAAA;ACwsCN;;ADzsCI;EACE,iBAAA;AC4sCN;;AD7sCI;EACE,iBAAA;ACgtCN;;ADjtCI;EACE,iBAAA;ACotCN;;ADrtCI;EACE,iBAAA;ACwtCN;;ADztCI;EACE,iBAAA;AC4tCN;;AD7tCI;EACE,iBAAA;ACguCN;;ADjuCI;EACE,iBAAA;ACouCN;;ADruCI;EACE,iBAAA;ACwuCN;;ADzuCI;EACE,iBAAA;AC4uCN;;AD7uCI;EACE,iBAAA;ACgvCN;;ADjvCI;EACE,iBAAA;ACovCN;;ADrvCI;EACE,iBAAA;ACwvCN;;ADzvCI;EACE,iBAAA;AC4vCN;;AD7vCI;EACE,iBAAA;ACgwCN;;ADjwCI;EACE,iBAAA;ACowCN;;ADrwCI;EACE,iBAAA;ACwwCN;;ADzwCI;EACE,iBAAA;AC4wCN;;AD7wCI;EACE,iBAAA;ACgxCN;;ADjxCI;EACE,iBAAA;ACoxCN;;ADrxCI;EACE,iBAAA;ACwxCN;;ADzxCI;EACE,iBAAA;AC4xCN;;AD7xCI;EACE,iBAAA;ACgyCN;;ADjyCI;EACE,iBAAA;ACoyCN;;ADryCI;EACE,iBAAA;ACwyCN;;ADzyCI;EACE,iBAAA;AC4yCN;;AD7yCI;EACE,iBAAA;ACgzCN;;ADjzCI;EACE,iBAAA;ACozCN;;ADrzCI;EACE,iBAAA;ACwzCN;;ADzzCI;EACE,iBAAA;AC4zCN;;AD7zCI;EACE,iBAAA;ACg0CN;;ADj0CI;EACE,iBAAA;ACo0CN;;ADr0CI;EACE,iBAAA;ACw0CN;;ADz0CI;EACE,iBAAA;AC40CN;;AD70CI;EACE,iBAAA;ACg1CN;;ADj1CI;EACE,iBAAA;ACo1CN;;ADr1CI;EACE,iBAAA;ACw1CN;;ADz1CI;EACE,iBAAA;AC41CN;;AD71CI;EACE,iBAAA;ACg2CN;;ADj2CI;EACE,iBAAA;ACo2CN;;ADr2CI;EACE,iBAAA;ACw2CN;;ADz2CI;EACE,iBAAA;AC42CN;;AD72CI;EACE,iBAAA;ACg3CN;;ADj3CI;EACE,iBAAA;ACo3CN;;ADr3CI;EACE,iBAAA;ACw3CN;;ADz3CI;EACE,iBAAA;AC43CN;;AD73CI;EACE,iBAAA;ACg4CN;;ADj4CI;EACE,iBAAA;ACo4CN;;ADr4CI;EACE,iBAAA;ACw4CN;;ADz4CI;EACE,iBAAA;AC44CN;;AD74CI;EACE,iBAAA;ACg5CN;;ADj5CI;EACE,iBAAA;ACo5CN;;ADr5CI;EACE,iBAAA;ACw5CN;;ADz5CI;EACE,iBAAA;AC45CN;;AD75CI;EACE,iBAAA;ACg6CN;;ADj6CI;EACE,iBAAA;ACo6CN;;ADr6CI;EACE,iBAAA;ACw6CN;;ADz6CI;EACE,iBAAA;AC46CN;;AD76CI;EACE,iBAAA;ACg7CN;;ADj7CI;EACE,iBAAA;ACo7CN;;ADr7CI;EACE,iBAAA;ACw7CN;;ADz7CI;EACE,iBAAA;AC47CN;;AD77CI;EACE,iBAAA;ACg8CN;;ADj8CI;EACE,iBAAA;ACo8CN;;ADr8CI;EACE,kBAAA;ACw8CN;;ADz8CI;EACE,gBAAA;AC48CN;;AD78CI;EACE,gBAAA;ACg9CN;;ADj9CI;EACE,gBAAA;ACo9CN;;ADr9CI;EACE,gBAAA;ACw9CN;;ADz9CI;EACE,gBAAA;AC49CN;;AD79CI;EACE,gBAAA;ACg+CN;;ADj+CI;EACE,gBAAA;ACo+CN;;ADr+CI;EACE,gBAAA;ACw+CN;;ADz+CI;EACE,gBAAA;AC4+CN;;AD7+CI;EACE,gBAAA;ACg/CN;;ADj/CI;EACE,iBAAA;ACo/CN;;ADr/CI;EACE,iBAAA;ACw/CN;;ADz/CI;EACE,iBAAA;AC4/CN;;AD7/CI;EACE,iBAAA;ACggDN;;ADjgDI;EACE,iBAAA;ACogDN;;ADrgDI;EACE,iBAAA;ACwgDN;;ADzgDI;EACE,iBAAA;AC4gDN;;AD7gDI;EACE,iBAAA;ACghDN;;ADjhDI;EACE,iBAAA;ACohDN;;ADrhDI;EACE,iBAAA;ACwhDN;;ADzhDI;EACE,iBAAA;AC4hDN;;AD7hDI;EACE,iBAAA;ACgiDN;;ADjiDI;EACE,iBAAA;ACoiDN;;ADriDI;EACE,iBAAA;ACwiDN;;ADziDI;EACE,iBAAA;AC4iDN;;AD7iDI;EACE,iBAAA;ACgjDN;;ADjjDI;EACE,iBAAA;ACojDN;;ADrjDI;EACE,iBAAA;ACwjDN;;ADzjDI;EACE,iBAAA;AC4jDN;;AD7jDI;EACE,iBAAA;ACgkDN;;ADjkDI;EACE,iBAAA;ACokDN;;ADrkDI;EACE,iBAAA;ACwkDN;;ADzkDI;EACE,iBAAA;AC4kDN;;AD7kDI;EACE,iBAAA;ACglDN;;ADjlDI;EACE,iBAAA;AColDN;;ADrlDI;EACE,iBAAA;ACwlDN;;ADzlDI;EACE,iBAAA;AC4lDN;;AD7lDI;EACE,iBAAA;ACgmDN;;ADjmDI;EACE,iBAAA;AComDN;;ADrmDI;EACE,iBAAA;ACwmDN;;ADzmDI;EACE,iBAAA;AC4mDN;;AD7mDI;EACE,iBAAA;ACgnDN;;ADjnDI;EACE,iBAAA;AConDN;;ADrnDI;EACE,iBAAA;ACwnDN;;ADznDI;EACE,iBAAA;AC4nDN;;AD7nDI;EACE,iBAAA;ACgoDN;;ADjoDI;EACE,iBAAA;ACooDN;;ADroDI;EACE,iBAAA;ACwoDN;;ADzoDI;EACE,iBAAA;AC4oDN;;AD7oDI;EACE,iBAAA;ACgpDN;;ADjpDI;EACE,iBAAA;ACopDN;;ADrpDI;EACE,iBAAA;ACwpDN;;ADzpDI;EACE,iBAAA;AC4pDN;;AD7pDI;EACE,iBAAA;ACgqDN;;ADjqDI;EACE,iBAAA;ACoqDN;;ADrqDI;EACE,iBAAA;ACwqDN;;ADzqDI;EACE,iBAAA;AC4qDN;;AD7qDI;EACE,iBAAA;ACgrDN;;ADjrDI;EACE,iBAAA;ACorDN;;ADrrDI;EACE,iBAAA;ACwrDN;;ADzrDI;EACE,iBAAA;AC4rDN;;AD7rDI;EACE,iBAAA;ACgsDN;;ADjsDI;EACE,iBAAA;ACosDN;;ADrsDI;EACE,iBAAA;ACwsDN;;ADzsDI;EACE,iBAAA;AC4sDN;;AD7sDI;EACE,iBAAA;ACgtDN;;ADjtDI;EACE,iBAAA;ACotDN;;ADrtDI;EACE,iBAAA;ACwtDN;;ADztDI;EACE,iBAAA;AC4tDN;;AD7tDI;EACE,iBAAA;ACguDN;;ADjuDI;EACE,iBAAA;ACouDN;;ADruDI;EACE,iBAAA;ACwuDN;;ADzuDI;EACE,iBAAA;AC4uDN;;AD7uDI;EACE,iBAAA;ACgvDN;;ADjvDI;EACE,iBAAA;ACovDN;;ADrvDI;EACE,iBAAA;ACwvDN;;ADzvDI;EACE,iBAAA;AC4vDN;;AD7vDI;EACE,iBAAA;ACgwDN;;ADjwDI;EACE,iBAAA;ACowDN;;ADrwDI;EACE,iBAAA;ACwwDN;;ADzwDI;EACE,iBAAA;AC4wDN;;AD7wDI;EACE,iBAAA;ACgxDN;;ADjxDI;EACE,iBAAA;ACoxDN;;ADrxDI;EACE,iBAAA;ACwxDN;;ADzxDI;EACE,iBAAA;AC4xDN;;AD7xDI;EACE,iBAAA;ACgyDN;;ADjyDI;EACE,iBAAA;ACoyDN;;ADryDI;EACE,iBAAA;ACwyDN;;ADzyDI;EACE,iBAAA;AC4yDN;;AD7yDI;EACE,iBAAA;ACgzDN;;ADjzDI;EACE,iBAAA;ACozDN;;ADrzDI;EACE,iBAAA;ACwzDN;;ADzzDI;EACE,iBAAA;AC4zDN;;AD7zDI;EACE,iBAAA;ACg0DN;;ADj0DI;EACE,iBAAA;ACo0DN;;ADr0DI;EACE,iBAAA;ACw0DN;;ADz0DI;EACE,iBAAA;AC40DN;;AD70DI;EACE,iBAAA;ACg1DN;;ADj1DI;EACE,iBAAA;ACo1DN;;ADr1DI;EACE,iBAAA;ACw1DN;;ADz1DI;EACE,kBAAA;AC41DN;;AD71DI;EACE,iBAAA;ACg2DN;;ADj2DI;EACE,iBAAA;ACo2DN;;ADr2DI;EACE,iBAAA;ACw2DN;;ADz2DI;EACE,iBAAA;AC42DN;;AD72DI;EACE,iBAAA;ACg3DN;;ADj3DI;EACE,iBAAA;ACo3DN;;ADr3DI;EACE,iBAAA;ACw3DN;;ADz3DI;EACE,iBAAA;AC43DN;;AD73DI;EACE,iBAAA;ACg4DN;;ADj4DI;EACE,iBAAA;ACo4DN;;ADr4DI;EACE,kBAAA;ACw4DN;;ADz4DI;EACE,kBAAA;AC44DN;;AD74DI;EACE,kBAAA;ACg5DN;;ADj5DI;EACE,kBAAA;ACo5DN;;ADr5DI;EACE,kBAAA;ACw5DN;;ADz5DI;EACE,kBAAA;AC45DN;;AD75DI;EACE,kBAAA;ACg6DN;;ADj6DI;EACE,kBAAA;ACo6DN;;ADr6DI;EACE,kBAAA;ACw6DN;;ADz6DI;EACE,kBAAA;AC46DN;;AD76DI;EACE,kBAAA;ACg7DN;;ADj7DI;EACE,kBAAA;ACo7DN;;ADr7DI;EACE,kBAAA;ACw7DN;;ADz7DI;EACE,kBAAA;AC47DN;;AD77DI;EACE,kBAAA;ACg8DN;;ADj8DI;EACE,kBAAA;ACo8DN;;ADr8DI;EACE,kBAAA;ACw8DN;;ADz8DI;EACE,kBAAA;AC48DN;;AD78DI;EACE,kBAAA;ACg9DN;;ADj9DI;EACE,kBAAA;ACo9DN;;ADr9DI;EACE,kBAAA;ACw9DN;;ADz9DI;EACE,kBAAA;AC49DN;;AD79DI;EACE,kBAAA;ACg+DN;;ADj+DI;EACE,kBAAA;ACo+DN;;ADr+DI;EACE,kBAAA;ACw+DN;;ADz+DI;EACE,kBAAA;AC4+DN;;AD7+DI;EACE,kBAAA;ACg/DN;;ADj/DI;EACE,kBAAA;ACo/DN;;ADr/DI;EACE,kBAAA;ACw/DN;;ADz/DI;EACE,kBAAA;AC4/DN;;AD7/DI;EACE,kBAAA;ACggEN;;ADjgEI;EACE,kBAAA;ACogEN;;ADrgEI;EACE,kBAAA;ACwgEN;;ADzgEI;EACE,kBAAA;AC4gEN;;AD7gEI;EACE,kBAAA;ACghEN;;ADjhEI;EACE,kBAAA;ACohEN;;ADrhEI;EACE,kBAAA;ACwhEN;;ADzhEI;EACE,kBAAA;AC4hEN;;AD7hEI;EACE,kBAAA;ACgiEN;;ADjiEI;EACE,kBAAA;ACoiEN;;ADriEI;EACE,kBAAA;ACwiEN;;ADziEI;EACE,kBAAA;AC4iEN;;AD7iEI;EACE,kBAAA;ACgjEN;;ADjjEI;EACE,kBAAA;ACojEN;;ADrjEI;EACE,kBAAA;ACwjEN;;ADzjEI;EACE,kBAAA;AC4jEN;;AD7jEI;EACE,kBAAA;ACgkEN;;ADjkEI;EACE,kBAAA;ACokEN;;ADrkEI;EACE,kBAAA;ACwkEN;;ADzkEI;EACE,kBAAA;AC4kEN;;AD7kEI;EACE,kBAAA;ACglEN;;ADjlEI;EACE,kBAAA;AColEN;;ADrlEI;EACE,kBAAA;ACwlEN;;ADzlEI;EACE,kBAAA;AC4lEN;;AD7lEI;EACE,kBAAA;ACgmEN;;ADjmEI;EACE,kBAAA;AComEN;;ADrmEI;EACE,kBAAA;ACwmEN;;ADzmEI;EACE,kBAAA;AC4mEN;;AD7mEI;EACE,kBAAA;ACgnEN;;ADjnEI;EACE,kBAAA;AConEN;;ADrnEI;EACE,kBAAA;ACwnEN;;ADznEI;EACE,kBAAA;AC4nEN;;AD7nEI;EACE,kBAAA;ACgoEN;;ADjoEI;EACE,kBAAA;ACooEN;;ADroEI;EACE,kBAAA;ACwoEN;;ADzoEI;EACE,kBAAA;AC4oEN;;AD7oEI;EACE,kBAAA;ACgpEN;;ADjpEI;EACE,kBAAA;ACopEN;;ADrpEI;EACE,kBAAA;ACwpEN;;ADzpEI;EACE,kBAAA;AC4pEN;;AD7pEI;EACE,kBAAA;ACgqEN;;ADjqEI;EACE,kBAAA;ACoqEN;;ADrqEI;EACE,kBAAA;ACwqEN;;ADzqEI;EACE,kBAAA;AC4qEN;;AD7qEI;EACE,kBAAA;ACgrEN;;ADjrEI;EACE,kBAAA;ACorEN;;ADrrEI;EACE,kBAAA;ACwrEN;;ADzrEI;EACE,kBAAA;AC4rEN;;AD7rEI;EACE,kBAAA;ACgsEN;;ADjsEI;EACE,kBAAA;ACosEN;;ADrsEI;EACE,kBAAA;ACwsEN;;ADzsEI;EACE,kBAAA;AC4sEN;;AD7sEI;EACE,kBAAA;ACgtEN;;ADjtEI;EACE,kBAAA;ACotEN;;ADrtEI;EACE,kBAAA;ACwtEN;;ADztEI;EACE,kBAAA;AC4tEN;;AD7tEI;EACE,kBAAA;ACguEN;;ADjuEI;EACE,kBAAA;ACouEN;;ADruEI;EACE,kBAAA;ACwuEN;;ADzuEI;EACE,kBAAA;AC4uEN;;AD7uEI;EACE,mBAAA;ACgvEN;;ADjvEI;EACE,kBAAA;ACovEN;;ADrvEI;EACE,kBAAA;ACwvEN;;ADzvEI;EACE,kBAAA;AC4vEN;;AD7vEI;EACE,kBAAA;ACgwEN;;ADjwEI;EACE,kBAAA;ACowEN;;ADrwEI;EACE,kBAAA;ACwwEN;;ADzwEI;EACE,kBAAA;AC4wEN;;AD7wEI;EACE,kBAAA;ACgxEN;;ADjxEI;EACE,kBAAA;ACoxEN;;ADrxEI;EACE,kBAAA;ACwxEN;;ADzxEI;EACE,mBAAA;AC4xEN;;AD7xEI;EACE,mBAAA;ACgyEN;;ADjyEI;EACE,mBAAA;ACoyEN;;ADryEI;EACE,mBAAA;ACwyEN;;ADzyEI;EACE,mBAAA;AC4yEN;;AD7yEI;EACE,mBAAA;ACgzEN;;ADjzEI;EACE,mBAAA;ACozEN;;ADrzEI;EACE,mBAAA;ACwzEN;;ADzzEI;EACE,mBAAA;AC4zEN;;AD7zEI;EACE,mBAAA;ACg0EN;;ADj0EI;EACE,mBAAA;ACo0EN;;ADr0EI;EACE,mBAAA;ACw0EN;;ADz0EI;EACE,mBAAA;AC40EN;;AD70EI;EACE,mBAAA;ACg1EN;;ADj1EI;EACE,mBAAA;ACo1EN;;ADr1EI;EACE,mBAAA;ACw1EN;;ADz1EI;EACE,mBAAA;AC41EN;;AD71EI;EACE,mBAAA;ACg2EN;;ADj2EI;EACE,mBAAA;ACo2EN;;ADr2EI;EACE,mBAAA;ACw2EN;;ADz2EI;EACE,mBAAA;AC42EN;;AD72EI;EACE,mBAAA;ACg3EN;;ADj3EI;EACE,mBAAA;ACo3EN;;ADr3EI;EACE,mBAAA;ACw3EN;;ADz3EI;EACE,mBAAA;AC43EN;;AD73EI;EACE,mBAAA;ACg4EN;;ADj4EI;EACE,mBAAA;ACo4EN;;ADr4EI;EACE,mBAAA;ACw4EN;;ADz4EI;EACE,mBAAA;AC44EN;;AD74EI;EACE,mBAAA;ACg5EN;;ADj5EI;EACE,mBAAA;ACo5EN;;ADr5EI;EACE,mBAAA;ACw5EN;;ADz5EI;EACE,mBAAA;AC45EN;;AD75EI;EACE,mBAAA;ACg6EN;;ADj6EI;EACE,mBAAA;ACo6EN;;ADr6EI;EACE,mBAAA;ACw6EN;;ADz6EI;EACE,mBAAA;AC46EN;;AD76EI;EACE,mBAAA;ACg7EN;;ADj7EI;EACE,mBAAA;ACo7EN;;ADr7EI;EACE,mBAAA;ACw7EN;;ADz7EI;EACE,mBAAA;AC47EN;;AD77EI;EACE,mBAAA;ACg8EN;;ADj8EI;EACE,mBAAA;ACo8EN;;ADr8EI;EACE,mBAAA;ACw8EN;;ADz8EI;EACE,mBAAA;AC48EN;;AD78EI;EACE,mBAAA;ACg9EN;;ADj9EI;EACE,mBAAA;ACo9EN;;ADr9EI;EACE,mBAAA;ACw9EN;;ADz9EI;EACE,mBAAA;AC49EN;;AD79EI;EACE,mBAAA;ACg+EN;;ADj+EI;EACE,mBAAA;ACo+EN;;ADr+EI;EACE,mBAAA;ACw+EN;;ADz+EI;EACE,mBAAA;AC4+EN;;AD7+EI;EACE,mBAAA;ACg/EN;;ADj/EI;EACE,mBAAA;ACo/EN;;ADr/EI;EACE,mBAAA;ACw/EN;;ADz/EI;EACE,mBAAA;AC4/EN;;AD7/EI;EACE,mBAAA;ACggFN;;ADjgFI;EACE,mBAAA;ACogFN;;ADrgFI;EACE,mBAAA;ACwgFN;;ADzgFI;EACE,mBAAA;AC4gFN;;AD7gFI;EACE,mBAAA;ACghFN;;ADjhFI;EACE,mBAAA;ACohFN;;ADrhFI;EACE,mBAAA;ACwhFN;;ADzhFI;EACE,mBAAA;AC4hFN;;AD7hFI;EACE,mBAAA;ACgiFN;;ADjiFI;EACE,mBAAA;ACoiFN;;ADriFI;EACE,mBAAA;ACwiFN;;ADziFI;EACE,mBAAA;AC4iFN;;AD7iFI;EACE,mBAAA;ACgjFN;;ADjjFI;EACE,mBAAA;ACojFN;;ADrjFI;EACE,mBAAA;ACwjFN;;ADzjFI;EACE,mBAAA;AC4jFN;;AD7jFI;EACE,mBAAA;ACgkFN;;ADjkFI;EACE,mBAAA;ACokFN;;ADrkFI;EACE,mBAAA;ACwkFN;;ADzkFI;EACE,mBAAA;AC4kFN;;AD7kFI;EACE,mBAAA;ACglFN;;ADjlFI;EACE,mBAAA;AColFN;;ADrlFI;EACE,mBAAA;ACwlFN;;ADzlFI;EACE,mBAAA;AC4lFN;;AD7lFI;EACE,mBAAA;ACgmFN;;ADjmFI;EACE,mBAAA;AComFN;;ADrmFI;EACE,mBAAA;ACwmFN;;ADzmFI;EACE,mBAAA;AC4mFN;;AD7mFI;EACE,mBAAA;ACgnFN;;ADjnFI;EACE,mBAAA;AConFN;;ADrnFI;EACE,mBAAA;ACwnFN;;ADznFI;EACE,mBAAA;AC4nFN;;AD7nFI;EACE,mBAAA;ACgoFN;;ADjoFI;EACE,oBAAA;ACooFN;;ADroFI;EACE,eAAA;ACwoFN;;ADzoFI;EACE,eAAA;AC4oFN;;AD7oFI;EACE,eAAA;ACgpFN;;ADjpFI;EACE,eAAA;ACopFN;;ADrpFI;EACE,eAAA;ACwpFN;;ADzpFI;EACE,eAAA;AC4pFN;;AD7pFI;EACE,eAAA;ACgqFN;;ADjqFI;EACE,eAAA;ACoqFN;;ADrqFI;EACE,eAAA;ACwqFN;;ADzqFI;EACE,eAAA;AC4qFN;;AD7qFI;EACE,gBAAA;ACgrFN;;ADjrFI;EACE,gBAAA;ACorFN;;ADrrFI;EACE,gBAAA;ACwrFN;;ADzrFI;EACE,gBAAA;AC4rFN;;AD7rFI;EACE,gBAAA;ACgsFN;;ADjsFI;EACE,gBAAA;ACosFN;;ADrsFI;EACE,gBAAA;ACwsFN;;ADzsFI;EACE,gBAAA;AC4sFN;;AD7sFI;EACE,gBAAA;ACgtFN;;ADjtFI;EACE,gBAAA;ACotFN;;ADrtFI;EACE,gBAAA;ACwtFN;;ADztFI;EACE,gBAAA;AC4tFN;;AD7tFI;EACE,gBAAA;ACguFN;;ADjuFI;EACE,gBAAA;ACouFN;;ADruFI;EACE,gBAAA;ACwuFN;;ADzuFI;EACE,gBAAA;AC4uFN;;AD7uFI;EACE,gBAAA;ACgvFN;;ADjvFI;EACE,gBAAA;ACovFN;;ADrvFI;EACE,gBAAA;ACwvFN;;ADzvFI;EACE,gBAAA;AC4vFN;;AD7vFI;EACE,gBAAA;ACgwFN;;ADjwFI;EACE,gBAAA;ACowFN;;ADrwFI;EACE,gBAAA;ACwwFN;;ADzwFI;EACE,gBAAA;AC4wFN;;AD7wFI;EACE,gBAAA;ACgxFN;;ADjxFI;EACE,gBAAA;ACoxFN;;ADrxFI;EACE,gBAAA;ACwxFN;;ADzxFI;EACE,gBAAA;AC4xFN;;AD7xFI;EACE,gBAAA;ACgyFN;;ADjyFI;EACE,gBAAA;ACoyFN;;ADryFI;EACE,gBAAA;ACwyFN;;ADzyFI;EACE,gBAAA;AC4yFN;;AD7yFI;EACE,gBAAA;ACgzFN;;ADjzFI;EACE,gBAAA;ACozFN;;ADrzFI;EACE,gBAAA;ACwzFN;;ADzzFI;EACE,gBAAA;AC4zFN;;AD7zFI;EACE,gBAAA;ACg0FN;;ADj0FI;EACE,gBAAA;ACo0FN;;ADr0FI;EACE,gBAAA;ACw0FN;;ADz0FI;EACE,gBAAA;AC40FN;;AD70FI;EACE,gBAAA;ACg1FN;;ADj1FI;EACE,gBAAA;ACo1FN;;ADr1FI;EACE,gBAAA;ACw1FN;;ADz1FI;EACE,gBAAA;AC41FN;;AD71FI;EACE,gBAAA;ACg2FN;;ADj2FI;EACE,gBAAA;ACo2FN;;ADr2FI;EACE,gBAAA;ACw2FN;;ADz2FI;EACE,gBAAA;AC42FN;;AD72FI;EACE,gBAAA;ACg3FN;;ADj3FI;EACE,gBAAA;ACo3FN;;ADr3FI;EACE,gBAAA;ACw3FN;;ADz3FI;EACE,gBAAA;AC43FN;;AD73FI;EACE,gBAAA;ACg4FN;;ADj4FI;EACE,gBAAA;ACo4FN;;ADr4FI;EACE,gBAAA;ACw4FN;;ADz4FI;EACE,gBAAA;AC44FN;;AD74FI;EACE,gBAAA;ACg5FN;;ADj5FI;EACE,gBAAA;ACo5FN;;ADr5FI;EACE,gBAAA;ACw5FN;;ADz5FI;EACE,gBAAA;AC45FN;;AD75FI;EACE,gBAAA;ACg6FN;;ADj6FI;EACE,gBAAA;ACo6FN;;ADr6FI;EACE,gBAAA;ACw6FN;;ADz6FI;EACE,gBAAA;AC46FN;;AD76FI;EACE,gBAAA;ACg7FN;;ADj7FI;EACE,gBAAA;ACo7FN;;ADr7FI;EACE,gBAAA;ACw7FN;;ADz7FI;EACE,gBAAA;AC47FN;;AD77FI;EACE,gBAAA;ACg8FN;;ADj8FI;EACE,gBAAA;ACo8FN;;ADr8FI;EACE,gBAAA;ACw8FN;;ADz8FI;EACE,gBAAA;AC48FN;;AD78FI;EACE,gBAAA;ACg9FN;;ADj9FI;EACE,gBAAA;ACo9FN;;ADr9FI;EACE,gBAAA;ACw9FN;;ADz9FI;EACE,gBAAA;AC49FN;;AD79FI;EACE,gBAAA;ACg+FN;;ADj+FI;EACE,gBAAA;ACo+FN;;ADr+FI;EACE,gBAAA;ACw+FN;;ADz+FI;EACE,gBAAA;AC4+FN;;AD7+FI;EACE,gBAAA;ACg/FN;;ADj/FI;EACE,gBAAA;ACo/FN;;ADr/FI;EACE,gBAAA;ACw/FN;;ADz/FI;EACE,gBAAA;AC4/FN;;AD7/FI;EACE,gBAAA;ACggGN;;ADjgGI;EACE,gBAAA;ACogGN;;ADrgGI;EACE,gBAAA;ACwgGN;;ADzgGI;EACE,gBAAA;AC4gGN;;AD7gGI;EACE,gBAAA;ACghGN;;ADjhGI;EACE,gBAAA;ACohGN;;ADrhGI;EACE,iBAAA;ACwhGN;ADpiGE;EAoCA;IACE,aAAA;IACA,UAAA;IACA,mBAAA;EC4hGF;EDzhGA;IACE,qBAAA;IACA,UAAA;IACA,YAAA;EC2hGF;AACF;ADzkGE;EAmDA;IACE,YAAA;IACA,qBAAA;EC6iGF;ED1iGA;IACE,UAAA;IACA,mBAAA;EC4iGF;AACF;ACluGA;EACE,mBAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,iCAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,8BAAA;EAEA,iBAAA;EACA,qBAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,uCAAA;EACA,wBAAA;EACA,+CAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,gEAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,qBAAA;EACA,8BAAA;EACA,mCAAA;EAEA,gBAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EAEA,iBAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,0DAAA;EACA,0DAAA;EACA,wDAAA;EAEA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,iBAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,gBAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EAEA,iBAAA;EACA,6DAAA;EACA,kEAAA;EACA,8DAAA;EACA,oEAAA;EAEA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AD0tGF;;ACvtGA,yCAAA;AACA;EACE,6CAAA;EACA,4BAAA,EAAA,iCAAA;EACA,4BAAA,EAAA,kCAAA;EACA,4BAAA,EAAA,mCAAA;EACA,4BAAA,EAAA,qCAAA;EACA,gDAAA,EAAA,oBAAA;EACA,4BAAA,EAAA,4BAAA;EACA,4BAAA,EAAA,4BAAA;EACA,4BAAA,EAAA,+BAAA;EAEA;;4DAAA;EAGA,2CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,gEAAA;EAEA,oDAAA;EACA,yBAAA,EAAA,mBAAA;EACA,yBAAA,EAAA,qBAAA;EACA,yBAAA,EAAA,6BAAA;EAEA,8BAAA;EACA,8BAAA,EAAA,oBAAA;EACA,kDAAA;EAEA,iDAAA;EACA,iCAAA,EAAA,yBAAA;EACA,iCAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,kBAAA;EACA,iCAAA,EAAA,mBAAA;EACA,iCAAA,EAAA,gBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,yBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,gBAAA;EACA,iCAAA,EAAA,wBAAA;EACA,iCAAA,EAAA,SAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,cAAA;EACA,iCAAA,EAAA,2BAAA;EAEA,yCAAA;EACA,kCAAA,EAAA,yBAAA;EACA,kCAAA,EAAA,mBAAA;EACA,kCAAA,EAAA,kBAAA;EACA,kCAAA,EAAA,kBAAA;EACA,qDAAA;EACA,qDAAA;EACA,mDAAA;EAEA,gDAAA;EACA,wBAAA,EAAA,iBAAA;EACA,wBAAA,EAAA,mBAAA;EACA,wBAAA,EAAA,2BAAA;EACA,0BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,kBAAA;EAEA,kDAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,yCAAA;EACA,gDAAA;EACA,iDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,iDAAA;EAEA,8BAAA;EACA,6DAAA;EACA,mEAAA;EACA,oEAAA;EACA,0EAAA;EACA,mBAAA;EACA,mBAAA;ADitGF;;AC9nGA;EACE,cA/EkB;ADgtGpB;;AC9nGA;EACE,cA/EkB;ADgtGpB;;AE3xGE;EACE,cAAA;AF8xGJ;;AE/xGE;EACE,cAAA;AFkyGJ;;AEnyGE;EACE,cAAA;AFsyGJ;;AEvyGE;EACE,cAAA;AF0yGJ;;AE3yGE;EACE,cAAA;AF8yGJ;;AE/yGE;EACE,cAAA;AFkzGJ;;AEnzGE;EACE,cAAA;AFszGJ;;AEvzGE;EACE,cAAA;AF0zGJ;;AE3zGE;EACE,cAAA;AF8zGJ;;AE/zGE;EACE,cAAA;AFk0GJ;;AEn0GE;EACE,cAAA;AFs0GJ;;AEv0GE;EACE,cAAA;AF00GJ;;AE30GE;EACE,cAAA;AF80GJ;;AE/0GE;EACE,gCAAA;AFk1GJ;;AEn1GE;EACE,cAAA;AFs1GJ;;AEv1GE;EACE,cAAA;AF01GJ;;AE31GE;EACE,cAAA;AF81GJ;;AE/1GE;EACE,cAAA;AFk2GJ;;AG3/GA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AH8/GF;;AG3/GA;EACE,YAAA;EACA,SAAA;EACA,UAAA;AH8/GF;;AG3/GA;EACE,gBAAA;EACA,WAAA;AH8/GF;;AG3/GA;EJyFE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;ACs6GF;;AG//GA;EJqFE,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;AC86GF;;AGngHA;EJkFE,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;ACs7GF;;AGvgHA;EACE,aAAA;AH0gHF;;AGvgHA;EJyEE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AC48GF;;AGnhHA;EJmEE,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AC89GF;;AG/hHA;EACE,wBAAA;AHkiHF;;AG/hHA;EACE,wBAAA;AHkiHF;;AG9hHE;EACE,kBAAA;AHiiHJ;AG9hHE;EACE,mBAAA;AHgiHJ;;AG5hHA;EACE,WAAA;EACA,YAAA;AH+hHF;;AG5hHA;EACE,yBF2LwB;ADo2G1B;;AG5hHA;EACE,4CAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AH+hHF;;AG3hHE;EACE,eAAA;AH8hHJ;AG3hHE;EACE,eAAA;AH6hHJ;;AGxhHA;EACE,oBAAA;AH2hHF;;AGvhHE;EACE,kBAAA;AH0hHJ;;AGj+GE;EACE,YAAA;AHo+GJ;AGj+GE;EACE,aAAA;AHm+GJ;AGh+GE;EACE,aAAA;AHk+GJ;AG/9GE;EACE,aAAA;AHi+GJ;;AIloHA;EACE,0BAPa;EAQb,iBAAA;EACA,eAAA;EACA,iBAAA;AJqoHF;;AIloHA;EACE,0BAAA;EACA,oBAAA;EACA,gBAAA;EACA,qHAAA;AJqoHF;AIloHA;EACE,0BAAA;EACA,oBAAA;EACA,gBAAA;EACA,sHAAA;AJooHF;AIjoHA;EACE,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,wHAAA;AJmoHF;AIhoHA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uHAAA;AJkoHF;AI/nHA;EACE,0BAAA;EACA,uHAAA;EACA,gBAAA;AJioHF;AI9nHA;EACE,0BAAA;EACA,qHAAA;EACA,iBAAA;EACA,gBAAA;AJgoHF;AI7nHA;EACE,0BAAA;EACA,yHAAA;EACA,iBAAA;EACA,gBAAA;AJ+nHF;AI5nHA;EACE,0BAAA;EACA,sHAAA;EACA,iBAAA;EACA,gBAAA;AJ8nHF;AI1nHA;EACE,0BAAA;EACA,0HAAA;EACA,iBAAA;EACA,gBAAA;AJ4nHF;AIvnHA;EACE,oBAAA;EACA,4CAAA;EACA,oBAAA;EACA,gBAAA;AJynHF;AItnHA;EACE,oBAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;AJwnHF;AIrnHA;EACE,oBAAA;EACA,4CAAA;EACA,iBAAA;EACA,gBAAA;AJunHF;AD7lHE;EM1HA;IN8GA,2BAAA;IAAA,qBAAA;IM3GE,UAAA;EL0xHF;EKvxHA;INwGA,wBAAA;IAAA,qBAAA;IMrGE,UAAA;ELiyHF;AACF;ADjrHE;EM5GA;INgGA,wBAAA;IAAA,qBAAA;IM7FE,UAAA;ELg2HF;EK71HA;IN0FA,2BAAA;IAAA,qBAAA;IMvFE,UAAA;ELu2HF;AACF;ADrwHE;EM9FA;INkFA,yBAAA;IMhFE,UAAA;EL84HF;EK34HA;IN6EA,qBAAA;IM3EE,UAAA;ELi5HF;AACF;AD3zHE;EMlFA;IAAM,SAAA;IAAW,UAAA;ELs6HjB;EKr6HA;IAAI,YAAA;IAAc,UAAA;ELy6HlB;AACF;ADz1HE;EM7EA;IAAM,YAAA;IAAc,UAAA;EL+7HpB;EK97HA;IAAI,SAAA;IAAW,UAAA;ELk8Hf;AACF;ADv3HE;EMvEA;IACE,4BAAA;ELi9HF;EK98HA;IACE,0BAAA;ELg9HF;AACF;AD/4HE;EM7DA;IACE,mBAAA;ELi+HF;EK99HA;IACE,mBAAA;IACA,aAAA;ELg+HF;AACF;AK79HA;EACE;IACE,UAAA;IACA,uCAAA;IACA,iBAAA;EL+9HF;EK79HA;IACE,UAAA;IACA,sCAAA;IACA,eAAA;EL+9HF;EK79HA;IACE,UAAA;IACA,iCAAA;IACA,eAAA;EL+9HF;AACF;AK59HA;EACE;IACE,UAAA;IACA,iCAAA;EL89HF;EK59HA;IACE,UAAA;IACA,uCAAA;IACA,WAAA;IAAA,6BAAA;EL89HF;AACF;AMjkIA;EAEE,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,qBAAA;EPsGA,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAAA,iBAAA;EOpGA,0BFXa;EEYb,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BAAA;ANilIF;AM1kIE;EPwFA,iBAAA;ACy/HF;AM7kIE;EACE,eAAA;EACA,oBAAA;AN+kIJ;AM5kIE;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AN8kIJ;AM3kIE;EACE,eAAA;AN6kIJ;AM1kIE;EACE,yBLgLgB;EK/KhB,cLiNsB;AD23H1B;AMjkII;EACE,yBLqMoB;EKpMpB,cLkKc;EKjKd,yBAAA;ANmkIN;AM3jIE;EACE,mBAAA;AN6jIJ;AMzjII;EACE,yBLqLoB;EKpLpB,cLkJc;EKjJd,yBAAA;AN2jIN;AMzjIM;EACE,cLgLkB;EK/KlB,yBL6IY;EK5IZ,yBAAA;AN2jIR;AMvjII;EACE,yBLyKoB;EKxKpB,cLkJgB;EKjJhB,yBAAA;ANyjIN;AMvjIM;EACE,cLoKkB;EKnKlB,yBL6Ic;EK5Id,yBAAA;ANyjIR;;AOxpIA;EAEE,iBAAA;EACA,kBAAA;ERwGA,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAAA,iBAAA;EQtGA,0BHTa;EGUb,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BAAA;APyqIF;AOlqIE;ER0FA,iBAAA;AC+kIF;AOrqIE;EACE,eAAA;EACA,oBAAA;APuqIJ;AOnqII;EACE,cAAA;APqqIN;AOnqIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACgmIF;AOhrII;EACE,cAAA;APkrIN;AOhrIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC6mIF;AO7rII;EACE,cAAA;AP+rIN;AO7rIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC0nIF;AO1sII;EACE,cAAA;AP4sIN;AO1sIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACuoIF;AOvtII;EACE,cAAA;APytIN;AOvtIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACopIF;AOpuII;EACE,cAAA;APsuIN;AOpuIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACiqIF;AOjvII;EACE,cAAA;APmvIN;AOjvIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC8qIF;AO9vII;EACE,cAAA;APgwIN;AO9vIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC2rIF;AO3wII;EACE,cAAA;AP6wIN;AO3wIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACwsIF;AOxxII;EACE,cAAA;AP0xIN;AOxxIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACqtIF;AOryII;EACE,cAAA;APuyIN;AOryIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACkuIF;AOlzII;EACE,cAAA;APozIN;AOlzIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC+uIF;AO/zII;EACE,cAAA;APi0IN;AO/zIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC4vIF;AO50II;EACE,gCAAA;AP80IN;AO50IM;EACE,6BAAA;EACA,2CAAA;EACA,gCAAA;ER0EN,gBAAA;ACywIF;AOz1II;EACE,cAAA;AP21IN;AOz1IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACsxIF;AOt2II;EACE,cAAA;APw2IN;AOt2IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACmyIF;AOn3II;EACE,cAAA;APq3IN;AOn3IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;ACgzIF;AOh4II;EACE,cAAA;APk4IN;AOh4IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;ER0EN,gBAAA;AC6zIF;;AQ56IA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;ETyGA,gBAAA;ESvGA,4CAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;ARk7IF;AQj7IE;EACE,kBAAA;ARm7IJ;AQh7IE;EACE,SAAA;ARk7IJ;AQ/6IE;EACE,cAAA;EACA,kBAAA;ARi7IJ;AQ96IE;EACE,WAAA;EACA,YAAA;EACA,eAAA;ARg7IJ;AQ56II;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yDAAA;EACA,eAAA;EACA,yBPsMmB;EOrMnB,cPwNoB;EOvNpB,kBAAA;EACA,0BJ3CS;EI4CT,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AR66IN;AQz6IM;EAhCF;IAiCI,kBAAA;IACA,0BAAA;ER46IN;AACF;AQz6II;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;EACA,YAAA;AR26IN;AQx6IM;EAbF;IAcI,qBAAA;IACA,0BAAA;ER26IN;AACF;AQv6IM;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;ARy6IR;AQn6II;EACE,yBAAA;EACA,cAAA;ARq6IN;AQn6IM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARy6IR;AQr6II;EACE,yBAAA;EACA,cAAA;ARu6IN;AQr6IM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR26IR;AQ/7II;EACE,yBAAA;EACA,cAAA;ARi8IN;AQ/7IM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARq8IR;AQj8II;EACE,yBAAA;EACA,cAAA;ARm8IN;AQj8IM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARu8IR;AQ39II;EACE,yBAAA;EACA,cAAA;AR69IN;AQ39IM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARi+IR;AQ79II;EACE,yBAAA;EACA,cAAA;AR+9IN;AQ79IM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARm+IR;AQv/II;EACE,yBAAA;EACA,cAAA;ARy/IN;AQv/IM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;AR6/IR;AQz/II;EACE,yBAAA;EACA,cAAA;AR2/IN;AQz/IM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR+/IR;AQnhJI;EACE,yBAAA;EACA,cAAA;ARqhJN;AQnhJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARyhJR;AQrhJI;EACE,yBAAA;EACA,cAAA;ARuhJN;AQrhJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR2hJR;AQ/iJI;EACE,yBAAA;EACA,cAAA;ARijJN;AQ/iJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARqjJR;AQjjJI;EACE,yBAAA;EACA,cAAA;ARmjJN;AQjjJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARujJR;AQ3kJI;EACE,yBAAA;EACA,cAAA;AR6kJN;AQ3kJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARilJR;AQ7kJI;EACE,yBAAA;EACA,cAAA;AR+kJN;AQ7kJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARmlJR;AQvmJI;EACE,yBAAA;EACA,cAAA;ARymJN;AQvmJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;AR6mJR;AQzmJI;EACE,yBAAA;EACA,cAAA;AR2mJN;AQzmJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR+mJR;AQnoJI;EACE,yBAAA;EACA,cAAA;ARqoJN;AQnoJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARyoJR;AQroJI;EACE,yBAAA;EACA,cAAA;ARuoJN;AQroJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR2oJR;AQ/pJI;EACE,yBAAA;EACA,cAAA;ARiqJN;AQ/pJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARqqJR;AQjqJI;EACE,yBAAA;EACA,cAAA;ARmqJN;AQjqJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARuqJR;AQ3rJI;EACE,yBAAA;EACA,cAAA;AR6rJN;AQ3rJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARisJR;AQ7rJI;EACE,yBAAA;EACA,cAAA;AR+rJN;AQ7rJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARmsJR;AQvtJI;EACE,yBAAA;EACA,cAAA;ARytJN;AQvtJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;AR6tJR;AQztJI;EACE,yBAAA;EACA,cAAA;AR2tJN;AQztJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR+tJR;AQnvJI;EACE,yBAAA;EACA,cAAA;ARqvJN;AQnvJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARyvJR;AQrvJI;EACE,yBAAA;EACA,cAAA;ARuvJN;AQrvJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR2vJR;AQ/wJI;EACE,2CAAA;EACA,gCAAA;ARixJN;AQ/wJM;EACE,gCAAA;EACA,2CAAA;ETMN,gBAAA;ESJM,8CAAA;ARqxJR;AQjxJI;EACE,2CAAA;EACA,gCAAA;ARmxJN;AQjxJM;EACE,gCAAA;EACA,2CAAA;ETNN,gBAAA;ESQM,8CAAA;ARuxJR;AQ3yJI;EACE,yBAAA;EACA,cAAA;AR6yJN;AQ3yJM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARizJR;AQ7yJI;EACE,yBAAA;EACA,cAAA;AR+yJN;AQ7yJM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARmzJR;AQv0JI;EACE,yBAAA;EACA,cAAA;ARy0JN;AQv0JM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;AR60JR;AQz0JI;EACE,yBAAA;EACA,cAAA;AR20JN;AQz0JM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR+0JR;AQn2JI;EACE,yBAAA;EACA,cAAA;ARq2JN;AQn2JM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARy2JR;AQr2JI;EACE,yBAAA;EACA,cAAA;ARu2JN;AQr2JM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;AR22JR;AQ/3JI;EACE,yBAAA;EACA,cAAA;ARi4JN;AQ/3JM;EACE,cAAA;EACA,yBAAA;ETMN,gBAAA;ESJM,8CAAA;ARq4JR;AQj4JI;EACE,yBAAA;EACA,cAAA;ARm4JN;AQj4JM;EACE,cAAA;EACA,yBAAA;ETNN,gBAAA;ESQM,8CAAA;ARu4JR;;AS9/JA;EACE,cRwPuB;EQvPvB,0BLFa;EKGb,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;ATigKF;AS//JE;EACE,0BAAA;ATigKJ;AS9/JE;EACE,YAAA;EACA,cRqOqB;AD2xJzB;AS7/JE;EV0FA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;ACs6JF;;AS7/JI;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yDAAA;EACA,eAAA;EACA,yBR8MmB;EQ7MnB,cRgOoB;EQ/NpB,kBAAA;EACA,0BLnCS;EKoCT,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ATggKN;AS7/JI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;AT+/JN;AS3/JM;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;AT6/JR;;AU/jKA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cToPuB;ESnPvB,kBAAA;EACA,aAAA;EACA,YAAA;AVkkKF;AUhkKE;EACE,WAAA;EACA,wEAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AVkkKJ;AU/jKE;EACE,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,cTiOqB;EShOrB,0BNzBW;EM0BX,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cT8NqB;ADm2JzB;AU9jKE;EACE,yBT+NsB;ADi2J1B;AU7jKE;EACE,yBT6NsB;ADk2J1B;;AWpmKA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AXumKF;AWpmKE;EACE,oBAAA;AXsmKJ;AWlmKI;EZgBF,WAAA;EYdI,mBAAA;EACA,UAAA;EACA,oCAAA;EZ8FJ,2EAAA;AC2gKF;AWnmKI;EACE,QAAA;EACA,2BAAA;EACA,UAAA;AXqmKN;AWpmKM;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;AXsmKR;AWjmKE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBVsNsB;EUrNtB,+CAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAOA,UAAA;EACA,qBAAA;EZsDF,2FAAA;EYnDE,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,2BAAA;AXgmKJ;AD1mKI;EYlBF;IAiBI,gBAAA;EX+mKJ;AACF;AWnmKI;EZyCF,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EY1CI,cVkLmB;EUjLnB,0BPtES;EOuET,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAAA,uBAAA;AX6mKN;AW1mKI;EACE,6BP9EU;EO+EV,cVsKmB;EUrKnB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EAAA,uBAAA;AX4mKN;AWzmKI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kDAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,yBAAA;EACA,6BAAA;AX2mKN;;AA9sKE;EACE,aAAA;AAitKJ;AA9sKE;EDoGA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EADA,iBAAA;EACA,cAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;ECnGE,mBAAA;AAguKJ;AA9tKI;EACE,yBAAA;EACA,mBAAA;EACA,yBCgPoB;ED/OpB,0CAAA;EACA,cC4Mc;ED3Md,yBAAA;EACA,0BIrBS;EJsBT,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AAguKN;ADvsKI;ECxCA;IAkBI,eAAA;IACA,gBAAA;IACA,iBAAA;EAiuKN;AACF;AA/tKM;EACE,eAAA;EACA,oBAAA;EACA,YAAA;EACA,yBCqNiB;AD4gKzB;AA9tKM;EACE,cCoNkB;EDnNlB,yBAAA;EACA,mBAAA;EACA,yBC+KY;ED9KZ,0CAAA;AAguKR;;AA1tKA;EACE,YAAA;EACA,YAAA;EACA,cC6LuB;ED5LvB,0BI3Da;AJwxKf;AA5tKE;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AA8tKJ;AA3tKE;EACE,gBAAA;EDsCF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAJA,0CAAA;EACA,uCAAA;EACA,sCAAA;EACA,qCAAA;EACA,kCAAA;EAJA,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;ACksKF;AAxuKI;EACE,gBAAA;EDiCJ,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAJA,2CAAA;EACA,wCAAA;EACA,uCAAA;EACA,sCAAA;EACA,mCAAA;EAJA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;ACytKF;AAzvKM;ED4BJ,6CAAA;EACA,0CAAA;EACA,yCAAA;EACA,wCAAA;EACA,qCAAA;ACguKF;AA5vKM;EACE,aAAA;EACA,WAAA;AA8vKR;AAzvKE;EACE,gBAAA;EACA,iBAAA;AA2vKJ;AAxvKE;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA0vKJ","sourcesContent":["$screen-xs-min: 425px;\n$screen-sm-min: 576px;\n$screen-md-min: 768px;\n$screen-lg-min: 992px;\n$screen-xl-min: 1200px;\n\n// Mixins\n@mixin xs { @media (min-width: #{$screen-xs-min}) {@content;} }\n@mixin on-small { @media (max-width: #{$screen-sm-min}) {@content;} }\n@mixin up-small { @media (min-width: #{$screen-sm-min}) {@content;} }\n@mixin md { @media (min-width: #{$screen-md-min}) {@content;} }\n@mixin lg { @media (min-width: #{$screen-lg-min}) {@content;} }\n@mixin xl { @media (min-width: #{$screen-xl-min}) {@content;} }\n\n$z-index: (\n  close: -1,\n  modal      : 30,\n  navigation : 10,\n  dropdown: 12,\n  sticky-element: 18,\n  pop-up    : 20,\n  highest: 32\n);\n\n@function z-index($key) {\n  @return map-get($z-index, $key);\n}\n\n@mixin z-index($key) {\n  z-index: z-index($key);\n}\n\n@mixin breakpoint($class) {\n  @if $class == xsmall {\n    @media (max-width: 576px) { @content; }\n  }\n\n  @else if $class == small-down {\n    @media (max-width: 768px) { @content; }\n  }\n\n  @else if $class == mobile {\n    @media (min-width: 576px) { @content; }\n  }\n\n  @else if $class == small {\n    @media (min-width: 768px) { @content; }\n  }\n\n  @else if $class == medium-down {\n    @media (max-width: 992px) { @content; }\n  }\n\n  @else if $class == medium {\n    @media (min-width: 992px) { @content; }\n  }\n\n  @else if $class == large {\n    @media (min-width: 1200px) { @content; }\n  }\n\n  @else if $class == large-down {\n    @media (max-width: 1200px) { @content; }\n  }\n\n  @else if $class == xlarge {\n    @media (min-width: 1440px) { @content; }\n  }\n\n  @else if $class == xlarge-down {\n    @media (max-width: 1440px) { @content; }\n  }\n\n  @else if $class == xlarge-up {\n    @media (min-width: 1600px) { @content; }\n  }\n\n  @else if $class == 2k-down {\n    @media (min-width: 1800px) { @content; }\n  }\n\n  @else if $class == 2k-up {\n    @media (min-width: 1920px) { @content; }\n  }\n\n  @else if $class == 4k-down {\n    @media (min-width: 2500px) { @content; }\n  }\n\n  @else if $class == 4k {\n    @media (min-width: 3839px) { @content; }\n  }\n\n  @else if $class == 5k {\n    @media (min-width: 5100px) { @content; }\n  }\n\n  @else if $class == 5k-up {\n    @media (min-width: 5121px) { @content; }\n  }\n\n  @else {\n    @warn \"Breakpoint mixin supports: xs, sm, md, lg\";\n  }\n}\n\n@mixin prefix($prop, $value) {\n  -webkit-#{$prop}: #{$value};\n  -moz-#{$prop}: #{$value};\n  -ms-#{$prop}: #{$value};\n  -o-#{$prop}: #{$value};\n  #{$prop}: #{$value};\n}\n\n@mixin keyframes($name) {\n  @-webkit-keyframes #{$name} {\n    @content;\n  }\n\n  @-moz-keyframes #{$name} {\n    @content;\n  }\n\n  @keyframes #{$name} {\n    @content;\n  }\n}\n\n$max: 100;\n$offset: 1;\n$unit: 'px';\n@mixin list-loop($className, $styleName) {\n  $i: 0;\n  @while $i <= $max {\n    #{$className + $i} {\n      #{$styleName}: #{$i + $unit};\n    }\n    $i: $i + $offset;\n  }\n}\n\n@include list-loop('.padding-l-', 'padding-left');\n@include list-loop('.padding-r-', 'padding-right');\n@include list-loop('.padding-b-', 'padding-bottom');\n@include list-loop('.padding-t-', 'padding-top');\n@include list-loop('.margin-l-', 'margin-left');\n@include list-loop('.margin-r-', 'margin-right');\n@include list-loop('.margin-b-', 'margin-bottom');\n@include list-loop('.margin-t-', 'margin-top');\n\n@mixin ScaleDownFromCenter {\n  @include animation(0, .3s, openScaleDownFromCenter, normal, 1, forwards);\n}\n\n@mixin closeScaleUpFromCenter {\n  @include animation(0, .3s, closeScaleUpFromCenter, normal, 1, forwards);\n}\n\n@include keyframes(closeScaleUpFromCenter) {\n  0% {\n    z-index: 4001;\n    opacity: 1;\n    teansform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.3);\n    opacity: 0;\n    z-index: -10;\n  }\n}\n\n\n@include keyframes(openScaleDownFromCenter) {\n  0% {\n    opacity: 0.5;\n    teansform: scale(1.4);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin animation ($delay, $duration, $animation, $direction, $iteration, $fillmode) {\n  animation-name: $animation;\n  -o-animation-name: $animation;\n  -moz-animation-name: $animation;\n  -webkit-animation-name: $animation;\n\n    animation-delay: $delay;\n  -o-animation-delay: $delay;\n  -moz-animation-delay: $delay;\n  -webkit-animation-delay: $delay;\n\n    animation-duration: $duration;\n  -o-animation-duration: $duration;\n  -moz-animation-duration: $duration;\n  -webkit-animation-duration: $duration;\n\n    animation-fill-mode: $fillmode;\n  -o-animation-fill-mode: $fillmode;\n  -moz-animation-fill-mode: $fillmode;\n  -webkit-animation-fill-mode: $fillmode;\n\n    animation-direction: $direction;\n  -o-animation-direction: $direction;\n  -moz-animation-direction: $direction;\n  -webkit-animation-direction: $direction;\n\n    animation-iteration-count: $iteration;\n  -o-animation-iteration-count: $iteration;\n  -moz-animation-iteration-count: $iteration;\n  -webkit-animation-iteration-count: $iteration;\n}\n\n@mixin sourcesButton {\n  @include prefix(display, flex);\n  @include prefix(flex-flow, row);\n  @include prefix(align-items, center);\n  @include prefix(justify-content, flex-end);\n  width: 100%;\n\n  &__item {\n    border: 1px solid $primary-color-500;\n    border-radius: 20px;\n    background-color: $primary-color-light-500;;\n    box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n    color: $primary-color-500;\n    border: 1px solid $primary-color-500;\n    font-family: $primary-font;\n    font-size: 11px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 15px;\n    padding: 5px 15px;\n    margin-top: 0;\n    cursor: pointer;\n    margin-left: 10px;\n\n    @include breakpoint(medium) { \n      font-size: 11px;\n      font-weight: 500;\n      padding: 7px 20px;\n    }\n\n    &[disabled] {\n      cursor: default;\n      pointer-events: none;\n      opacity: .6;\n      background-color: $primary-color-dark-100;\n    }\n\n    &.selected {\n      color: $primary-color-light-500;\n      border: 1px solid $primary-color-500;\n      border-radius: 20px;\n      background-color: $primary-color-500;\n      box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n    }\n  }\n}\n","@import 'scss/main.scss';\n\n.heatmap-view {\n  & * + * {\n    margin-top: 0;\n  }\n\n  &__sources {\n    @include prefix(display, flex);\n    @include prefix(flex-flow, row);\n    @include prefix(align-items, center);\n    @include prefix(justify-content, flex-end);\n    margin-bottom: 20px;\n\n    &__item {\n      border: 1px solid $primary-color-500;\n      border-radius: 20px;\n      background-color: $primary-color-light-500;;\n      box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n      color: $primary-color-500;\n      border: 1px solid $primary-color-500;\n      font-family: $primary-font;\n      font-size: 11px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 15px;\n      padding: 5px 15px;\n      margin-top: 0;\n      cursor: pointer;\n      margin-left: 10px;\n\n      @include breakpoint(medium) { \n        font-size: 11px;\n        font-weight: 500;\n        padding: 7px 20px;\n      }\n\n      &[disabled] {\n        cursor: default;\n        pointer-events: none;\n        opacity: .6;\n        background-color: $primary-color-dark-100;\n      }\n\n      &.selected {\n        color: $primary-color-light-500;\n        border: 1px solid $primary-color-500;\n        border-radius: 20px;\n        background-color: $primary-color-500;\n        box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n      }\n    }\n  }\n}\n\n.heatmap-tooltip {\n  width: 375px;\n  height: auto;\n  color: $primary-color-dark-550;\n  font-family: $primary-font;\n  &__title {\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: 0.4px;\n    line-height: 1.2;\n    text-transform: uppercase;\n  }\n\n  ul {\n    list-style: none;\n    @include prefix(display, grid);\n    @include prefix(grid-template-columns, 1fr 1fr 1fr);\n    @include prefix(grid-template-rows, auto);\n    li {\n      margin-top: 10px;\n      @include prefix(display, grid);\n      @include prefix(grid-template-columns, 15px 2fr 1fr);\n      @include prefix(grid-template-rows, 1);\n      @include prefix(align-items, center);\n      &.sort {\n        @include prefix(grid-template-columns, 15px 45px auto);\n      }\n\n      &:before {\n        display: none;\n        content: \"\";\n      }\n    }\n  }\n\n  h5 { \n    margin-top: 15px;\n    font-weight: bold;\n  }\n\n  p {\n    word-wrap: break-word;\n    width: 100%;\n    white-space: normal;\n    word-break: break-word;\n    font-size: 14px;\n    margin-top: 10px;\n  }\n}\n",":root {\n  /* Primary colors */\n  --primary-color-100: #779BB0;\n  --primary-color-300: #454B56;\n  --primary-color-400: #294369;\n  --primary-color-500: #152935;\n  --primary-color-500-50: #2e5c9a80;\n  --primary-color-600: #1c1f27;\n  --primary-color-650: #1b1e26;\n  --primary-color-700: #1a2634;\n\n  --secondary-color-500: #006cff;\n  // --rs-btn-primary-bg: var(--primary-color-500);\n  --rs-gray-0: #fff;\n  --rs-gray-50: #f7f7fa;\n  --rs-gray-100: var(--primary-color-dark-100);\n  --rs-gray-200: var(--primary-color-dark-200);\n  --rs-gray-300: var(--primary-color-dark-300);\n  --rs-gray-400: var(--primary-color-dark-400);\n  --rs-gray-500: var(--primary-color-dark-500);\n  --rs-gray-600: var(--primary-color-dark-600);\n  --rs-gray-700: var(--primary-color-dark-700);\n  --rs-gray-800: var(--primary-color-dark-800);\n  --rs-gray-900: var(--primary-color-700);\n  --rs-primary-50: #f2faff;\n  --rs-primary-100: var(--primary-color-dark-100);\n  --rs-primary-200: var(--primary-color-dark-200);\n  --rs-primary-400: var(--primary-color-400);\n  --rs-primary-500: var(--primary-color-500);\n  --rs-primary-600: var(--primary-color-600);\n  --rs-primary-700: var(--primary-color-700);\n  --rs-primary-800: var(--primary-color-dark-800);\n  --rs-primary-900: var(--primary-color-dark-900);\n  --rs-bg-overlay: var(--primary-color-light-500);\n  --rs-calendar-date-selected-text: var(--primary-color-light-500);\n  /* Accent colors */\n  --accent-color-1: #1B57D1;\n  --accent-color-2: #FF832B;\n  --accent-color-3: #fe7b06;\n  \n  /* Secondary colors */\n  --secondary-color-300: #71C187;\n  --secondary-color-300-50: #71c18780;\n  \n  /* Dark colors */\n  --primary-color-dark-900: #000000;\n  --primary-color-dark-850: #040D0B;\n  --primary-color-dark-800: #152935;\n  --primary-color-dark-750: #1C1F27;\n  --primary-color-dark-720: #272727;\n  --primary-color-dark-700: #353333;\n  --primary-color-dark-650: #383c42;\n  --primary-color-dark-610: #393b42;\n  --primary-color-dark-600: #3F4A50;\n  --primary-color-dark-550: #484848;\n  --primary-color-dark-500: #535353;\n  --primary-color-dark-400: #646464;\n  --primary-color-dark-375: #676767;\n  --primary-color-dark-350: #736F6F;\n  --primary-color-dark-300: #818078;\n  --primary-color-dark-200: #AAAAAA;\n  --primary-color-dark-100: #BCBCBC;\n  \n  /* Light colors */\n  --primary-color-light-500: #FFFFFF;\n  --primary-color-light-300: #F4F4F4;\n  --primary-color-light-200: #F5F5F5;\n  --primary-color-light-150: #F6FAFE;\n  --primary-color-light-opacity-59: rgba(255, 255, 255, .59);\n  --primary-color-light-opacity-45: rgba(255, 255, 255, .45);\n  --primary-color-light-opacity-2: rgba(255, 255, 255, .2);\n  \n  /* Alert and danger colors */\n  --alert-color-1: #DA1E28;\n  --alert-color-2: #24A148;\n  --alert-color-3: #4a944f;\n  --warning-color-1: #f1c755;\n  --danger-color-300: #C17D71;\n  --danger-color-500: #D7563F;\n  \n  /* Brand colors */\n  --facebook-brand-color: #1A77F3;\n  --linkedin-brand-color: #007DBB;\n  --twitter-brand-color: #03A9F4;\n  \n  /* Box shadows */\n  --box-shadow-primary-5: rgba(0, 0, 0, 0.5);\n  --box-shadow-primary-7: rgba(0, 0, 0, 0.07);\n  --box-shadow-primary-12: rgba(0, 0, 0, 0.12);\n  --box-shadow-primary-13: rgba(0, 0, 0, 0.13);\n  --box-shadow-primary-14: rgba(0, 0, 0, 0.14);\n  --box-shadow-primary-16: rgba(0, 0, 0, 0.16);\n  --box-shadow-primary-18: rgba(0, 0, 0, 0.18);\n  --box-shadow-primary-19: rgba(0, 0, 0, 0.19);\n  --box-shadow-primary-22: rgba(0, 0, 0, 0.22);\n  --box-shadow-primary-25: rgba(0, 0, 0, 0.25);\n  --box-shadow-primary-57: rgba(0, 0, 0, 0.57);\n  \n  /* Card shadows */\n  --card-view-box-shadow: 0 2px 6px 0 rgba(109, 109, 109, 0.08);\n  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(109, 109, 109, 0.5);\n  --card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);\n  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(0, 0, 0, 0.28);\n\n  --z-index-close: -1;\n  --z-index-popup: 12;\n  --z-index-tooltip: 11;\n  --z-index-popup-light: 10;\n  --z-index-sticky: 9;\n}\n\n/* Dark Theme - Reversed/Adapted Colors */\n:root[data-theme=\"dark\"] {\n  /* Primary colors - Reversed for dark theme */\n  --primary-color-100: #BCBCBC;        /* Was #779BB0 - now light grey */\n  --primary-color-300: #AAAAAA;        /* Was #454B56 - now medium grey */\n  --primary-color-400: #779BB0;        /* Was #294369 - now original 100 */\n  --primary-color-500: #FFFFFF;        /* Was #152935 - now white for text */\n  --primary-color-500-50: rgba(188, 188, 188, 0.5); /* Adapted opacity */\n  --primary-color-600: #F4F4F4;        /* Was #1c1f27 - now light */\n  --primary-color-650: #F5F5F5;        /* Was #1b1e26 - now light */\n  --primary-color-700: #F6FAFE;        /* Was #1a2634 - now lightest */\n\n  /* Mirror rs- (design-system) variables for dark theme so overrides\n     in :root are reversed appropriately in dark mode. These reference\n     the dark-theme primary/light variables defined above. */\n  --rs-gray-0: var(--primary-color-light-500);\n  --rs-gray-50: var(--primary-color-light-300);\n  --rs-gray-100: var(--primary-color-dark-100);\n  --rs-gray-200: var(--primary-color-dark-200);\n  --rs-gray-300: var(--primary-color-dark-300);\n  --rs-gray-400: var(--primary-color-dark-400);\n  --rs-gray-500: var(--primary-color-dark-500);\n  --rs-gray-600: var(--primary-color-dark-600);\n  --rs-gray-700: var(--primary-color-dark-700);\n  --rs-gray-800: var(--primary-color-dark-800);\n  --rs-gray-900: var(--primary-color-700);\n  --rs-primary-50: var(--primary-color-light-150);\n  --rs-primary-100: var(--primary-color-dark-100);\n  --rs-primary-200: var(--primary-color-dark-200);\n  --rs-primary-400: var(--primary-color-400);\n  --rs-primary-500: var(--primary-color-500);\n  --rs-primary-600: var(--primary-color-600);\n  --rs-primary-700: var(--primary-color-700);\n  --rs-primary-800: var(--primary-color-dark-800);\n  --rs-primary-900: var(--primary-color-dark-900);\n  --rs-bg-overlay: var(--primary-color-light-500);\n  --rs-calendar-date-selected-text: var(--primary-color-light-500);\n  \n  /* Accent colors - Brightened for dark backgrounds */\n  --accent-color-1: #4A7FE7;          /* Lightened blue */\n  --accent-color-2: #FF9A4D;          /* Lightened orange */\n  --accent-color-3: #FF8C2B;          /* Lightened orange variant */\n  \n  --secondary-color-500: #006cff;\n  --secondary-color-300: #8FD4A4;     /* Lightened green */\n  --secondary-color-300-50: rgba(143, 212, 164, 0.5);\n  \n  /* Dark colors become background/surface colors */\n  --primary-color-dark-900: #FFFFFF;   /* Reversed - now white */\n  --primary-color-dark-850: #F6FAFE;   /* Light background */\n  --primary-color-dark-800: #F5F5F5;   /* Light surface */\n  --primary-color-dark-750: #F4F4F4;   /* Light elevated */\n  --primary-color-dark-720: #EEEEEE;   /* Light hover */\n  --primary-color-dark-700: #E8E8E8;   /* Light active */\n  --primary-color-dark-650: #E0E0E0;   /* Light border */\n  --primary-color-dark-610: #DDDDDD;   /* Light border variant */\n  --primary-color-dark-600: #D8D8D8;   /* Light subtle */\n  --primary-color-dark-550: #CCCCCC;   /* Medium light */\n  --primary-color-dark-500: #BBBBBB;   /* Medium */\n  --primary-color-dark-400: #AAAAAA;   /* Medium dark */\n  --primary-color-dark-375: #999999;   /* Medium dark variant */\n  --primary-color-dark-350: #888888;   /* Dark */\n  --primary-color-dark-300: #777777;   /* Darker */\n  --primary-color-dark-200: #555555;   /* Very dark */\n  --primary-color-dark-100: #454B56;   /* Darkest - original 300 */\n  \n  /* Light colors become dark backgrounds */\n  --primary-color-light-500: #000000;  /* Main dark background */\n  --primary-color-light-300: #040D0B;  /* Dark secondary */\n  --primary-color-light-200: #152935;  /* Dark tertiary */\n  --primary-color-light-150: #1C1F27;  /* Dark elevated */\n  --primary-color-light-opacity-59: rgba(0, 0, 0, 0.59);\n  --primary-color-light-opacity-45: rgba(0, 0, 0, 0.45);\n  --primary-color-light-opacity-2: rgba(0, 0, 0, 0.2);\n  \n  /* Alert and danger colors - Enhanced for dark */\n  --alert-color-1: #FF4757;           /* Brighter red */\n  --alert-color-2: #2ECC71;           /* Brighter green */\n  --alert-color-3: #27AE60;           /* Brighter green variant */\n  --warning-color-1: #F39C12;         /* Brighter yellow */\n  --danger-color-300: #E74C3C;        /* Brighter danger */\n  --danger-color-500: #C0392B;        /* Darker danger */\n  \n  /* Brand colors - Lightened for dark backgrounds */\n  --facebook-brand-color: #4267B2;\n  --linkedin-brand-color: #0077B5;\n  --twitter-brand-color: #1DA1F2;\n  \n  /* Box shadows - Adapted for dark theme */\n  --box-shadow-primary-5: rgba(255, 255, 255, 0.1);\n  --box-shadow-primary-7: rgba(255, 255, 255, 0.07);\n  --box-shadow-primary-12: rgba(255, 255, 255, 0.12);\n  --box-shadow-primary-13: rgba(255, 255, 255, 0.13);\n  --box-shadow-primary-14: rgba(255, 255, 255, 0.14);\n  --box-shadow-primary-16: rgba(255, 255, 255, 0.16);\n  --box-shadow-primary-18: rgba(255, 255, 255, 0.18);\n  --box-shadow-primary-19: rgba(255, 255, 255, 0.19);\n  --box-shadow-primary-22: rgba(255, 255, 255, 0.22);\n  --box-shadow-primary-25: rgba(255, 255, 255, 0.25);\n  --box-shadow-primary-57: rgba(255, 255, 255, 0.1);\n  \n  /* Card shadows - Dark theme */\n  --card-view-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.08);\n  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(255, 255, 255, 0.15);\n  --card-view-box-shadow-light: -1px 1px 8px rgba(255, 255, 255, 0.11);\n  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(255, 255, 255, 0.25);\n  --z-index-popup: 10;\n  --z-index-sticky: 9;\n}\n\n$primary-color-100: #779BB0;\n$primary-color-300: #454B56;\n$primary-color-500: #152935;\n$primary-color-500-50: #2e5c9a80;\n$primary-color-600: #1c1f27;\n$primary-color-650: #1b1e26;\n$primary-color-700: #1a2634;\n$primary-color-400: #294369;\n\n$accent-color-1: #1B57D1;\n$accent-color-2: #FF832B;\n$accent-color-3: #fe7b06;\n\n$secondary-color-500: #006cff;\n$secondary-color-300: #71C187;\n$secondary-color-300-50: #71c18780;\n\n$primary-color-dark-900: #000000;\n$primary-color-dark-850: #040D0B;\n$primary-color-dark-800: #152935;\n$primary-color-dark-750: #1C1F27;\n$primary-color-dark-720: #272727;\n$primary-color-dark-700: #353333;\n$primary-color-dark-650: #383c42;\n$primary-color-dark-610: #393b42;\n$primary-color-dark-600: #3F4A50;\n$primary-color-dark-550: #484848;\n$primary-color-dark-500: #535353;\n$primary-color-dark-400: #646464;\n$primary-color-dark-375: #676767;\n$primary-color-dark-350: #736F6F;\n$primary-color-dark-300: #818078;\n$primary-color-dark-200: #AAAAAA;\n$primary-color-dark-100: #BCBCBC;\n\n// primary light color\n$primary-color-light-500: #FFFFFF;\n\n$primary-color-light-300: #F4F4F4;\n$primary-color-light-200: #F5F5F5;\n$primary-color-light-150: #F6FAFE;\n$alert-color-3: #4a944f;\n$alert-color-2: #24A148;\n\n$primary-color-light-opacity-59: rgba(255, 255, 255, .59);\n$primary-color-light-opacity-45: rgba(255, 255, 255, .45);\n$primary-color-light-opacity-2: rgba(255, 255, 255, .2);\n\n\n// danger color\n\n$alert-color-1: #DA1E28;\n$warning-color-1: #f1c755;\n$danger-color-300: #C17D71;\n$danger-color-500: #D7563F;\n\n\n// brand colors\n$facebook-brand-color: #1A77F3;\n$linkedin-brand-color: #007DBB;\n$twitter-brand-color: #03A9F4;\n\n$box-shadow-primary-5: rgba(0, 0, 0, 0.5);\n$box-shadow-primary-7: rgba(0, 0, 0, 0.07);\n$box-shadow-primary-18: rgba(0,0,0,0.18);\n$box-shadow-primary-14: rgba(0, 0, 0, 0.14);\n$box-shadow-primary-16: rgba(0, 0, 0, 0.16);\n$box-shadow-primary-13: rgba(0, 0, 0, 0.13);\n$box-shadow-primary-12: rgba(0, 0, 0, 0.12);\n$box-shadow-primary-25: rgba(0, 0, 0, 0.25);\n$box-shadow-primary-19: rgba(0, 0, 0, 0.19);\n$box-shadow-primary-22: rgba(0, 0, 0, 0.22);\n$box-shadow-primary-57: rgba(0, 0, 0, 0.57);\n\n$card-view-box-shadow: 0 2px 6px 0 rgba(109,109,109,0.08);\n$card-view-box-shadow-hover: 0 3px 7px 0 rgba(109,109,109,0.5);\n\n$card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);\n$card-view-box-shadow-light-hover:  -1px 1px 8px rgba(0, 0, 0, 0.28);\n\n.color-primary {\n  color: $primary-color-500;\n}\n\n.color-primary-700 {\n  color: $primary-color-700\n}\n","\n$color-name-list: (\n  \"primary-dark\",\n  \"aqua-green\",\n  \"green\",\n  \"green-dark\",\n  \"green-light\",\n  \"purple\",\n  \"red\",\n  \"red-light\",\n  \"orange\",\n  \"blue\",\n  \"blue-grey\",\n  \"blue-2\",\n  \"yellow\",\n  \"gray\",\n  \"light-green\",\n  \"pink\",\n  \"blue-high\",\n  \"blue-2-high\"\n);\n\n$tooltip-color-name-list: ( \n  \"aqua-green\",\n  \"green\",\n  \"green-dark\",\n  \"purple\",\n  \"red\",\n  \"red-light\",\n  \"orange\",\n  \"blue\",\n  \"blue-grey\",\n  \"blue-2\",\n  \"blue-3\",\n  \"blue-dark\",\n  \"yellow\",\n  \"gray\",\n  \"light-green\",\n  \"pink\",\n  \"accent-blue\",\n  \"accent-red\",\n  \"accent-orange\",\n  \"accent-green\",\n  \"accent-green-2\",\n  \"accent-yellow\"\n);\n\n$banner-color-name-list: (\n  \"primary-dark\",\n  \"secondary-dark\",\n  \"accent-1\",\n  \"accent-2\",\n  \"accent-3\",\n);\n\n$tooltip-colors: (\n  \"aqua-green\": #3BCFB2,\n  \"green\": #54ebae,\n  \"green-dark\": #51d858,\n  \"purple\": #292F69,\n  \"red\": #692929,\n  \"red-light\": #D0021B,\n  \"orange\":  #DD5944,\n  \"blue\": #4b658b,\n  \"blue-3\": #4F99EA,\n  \"blue-grey\": #294369,\n  \"blue-2\": #3165B2,\n  \"blue-dark\": #3965c7,\n  \"yellow\": #f8df71,\n  \"gray\": rgba(141,141,141,0.85),\n  \"light-green\": #71C187,\n  \"pink\": #572969,\n  \"accent-blue\": #1B57D1,\n  \"accent-red\": #d11b1b,\n  \"accent-orange\": #d1641b,\n  \"accent-green\": #1bd194,\n  \"accent-green-2\": #39d11b,\n  \"accent-yellow\": #f7e70f,\n);\n\n$banner-colors: (\n  \"primary-dark\": #152935,\n  \"secondary-dark\": #29694F,\n  \"accent-1\": #1B57D1,\n  \"accent-2\": #FF832B,\n  \"accent-3\": #692929\n);\n\n$attribute-colors: (\n  \"primary-dark\": #1B1E26,\n  \"aqua-green\": #3BCFB2,\n  \"green\": #29694F,\n  \"green-dark\": #2A624A,\n  \"green-light\": #579A6E,\n  \"purple\": #292F69,\n  \"red\": #692929,\n  \"red-light\": #D0021B,\n  \"orange\":  #DD5944,\n  \"blue\": #294369,\n  \"blue-grey\": #294369,\n  \"blue-2\": #3165B2,\n  \"yellow\": #19160C,\n  \"gray\": rgba(141,141,141,0.85),\n  \"light-green\": #71C187,\n  \"pink\": #572969,\n  \"blue-high\": #F6FAFE,\n  \"blue-2-high\": #F6FAFE\n);\n\n$attribute-hover-colors: (\n  \"primary-dark\": #FF832B,\n  \"aqua-green\": #E2FFF5,\n  \"green\": #F6FEF9,\n  \"green-dark\": #F6FEF9,\n  \"green-light\": #F6FEF9,\n  \"purple\": #F6F7FE,\n  \"red\": #FEF6F6,\n  \"red-light\": #FEF6F6,\n  \"orange\": #FEF6F6,\n  \"blue\": #F6FAFE,\n  \"blue-grey\": #f5f5f5,\n  \"blue-2\": #F6FAFE,\n  \"yellow\": #FBFEDC,\n  \"gray\": rgba(241,241,241,0.87),\n  \"light-green\": #F6FEF9,\n  \"pink\": #FAF6FE,\n  \"blue-high\": #294369,\n  \"blue-2-high\": #3165B2\n);\n\n$attribute-background-colors: (\n  \"primary-dark\": #FFFFFF,\n  \"aqua-green\": #E2FFF5,\n  \"green\": #F6FEF9,\n  \"green-dark\": #F6FEF9,\n  \"green-light\": #F6FEF9,\n  \"purple\": #F6F7FE,\n  \"red\": #FEF6F6,\n  \"red-light\": #FEF6F6,\n  \"orange\":  #FEF6F6,\n  \"blue\": #F6FAFE,\n  \"blue-grey\": #f5f5f5,\n  \"blue-2\": #F6FAFE,\n  \"yellow\": #FBFEDC,\n  \"gray\": rgba(241,241,241,0.87),\n  \"light-green\": #F6FEF9,\n  \"pink\": #FAF6FE,\n  \"blue-high\": #294369,\n  \"blue-2-high\": #3165B2\n);\n\n@each $color-name in $color-name-list {\n  .color-#{$color-name} {\n    color: map-get($attribute-colors, $color-name);\n  }\n}\n","body {\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n}\n\nhtml {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n#root {\n  min-height: 100%;\n  width: 100%;\n}\n\n.display-flex {\n  @include prefix(display, flex); \n}\n\n.display-inline-flex {\n  @include prefix(display, inline-flex);\n}\n\n.justify-content-flex-end {\n  @include prefix(justify-content, flex-end);\n}\n\n.display--none {\n  display: none;\n}\n\n.display-flex-center {\n  @include prefix(display, flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n}\n\n.display-inline-flex-center {\n  @include prefix(display, inline-flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n}\n\n.highlight-text, .HIGHLIGHT-TEXT {\n  background-color: yellow;\n}\n\n.row:before, .row:after {\n  display: none !important;\n}\n\n.visibility {\n  &--hidden {\n    visibility: hidden;\n  }\n\n  &--visible {\n    visibility: visible;\n  }\n}\n\n.responsive-image {\n  width: 100%;\n  height: auto;\n}\n\n.bg-light {\n  background-color: $primary-color-light-500;\n}\n\n.sidenav {\n  transition: margin-left .3s, max-width .3s;\n  margin-left: 0px;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.cursor {\n  &--default {\n    cursor: default;\n  }\n\n  &--pointer {\n    cursor: pointer;\n  }\n}\n\n\n.disable-link {\n  pointer-events: none;\n}\n\n.position {\n  &--relative {\n    position: relative;\n  }\n}\n\n@mixin data-tooltip-class {\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    &:after {\n      display: none;\n      @include prefix(justify-content, center);\n      @include prefix(align-items, center);\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      bottom: 100%;\n      background-color: $primary-color-500;\n      color: $primary-color-light-500;\n      box-shadow: $card-view-box-shadow-hover;\n      text-align: center;\n      font-family: $primary-font;\n      font-size: 14px;\n      font-weight: normal;\n      padding: 15px 10px;\n      border-radius: 10px;\n      top: calc(100% + 20px);\n      max-height: 0;\n      z-index: 1;\n      white-space: nowrap;\n      max-width: 400px;\n      width: auto;\n      transform: translateY(-50%);\n      left: 0%;\n    }\n  \n    &:before {\n      content: \" \";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateY(-50%);\n      visibility: hidden;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-500 transparent;\n    }\n  \n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n}\n\n.opacity {\n\n  &-5 {\n    opacity: .5;\n  }\n\n  &-25 {\n    opacity: .25;\n  }\n\n  &-15 {\n    opacity: .15;\n  }\n\n  &-1 {\n    opacity: .01;\n  }\n  \n}\n","$primary-font: 'Public Sans';\n$secondary-font: Avenir;\n$tertiary-font: 'Helvetica Neue';\n$fortiary-font: \"Poppins\", sans-serif;\n$Aller: \"Aller\";\n\n.font-primary-bold-normal {\n  font-family: $primary-font;\n  font-weight: bold;\n  font-size: 18px;\n  letter-spacing: 0;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: lighter;\n  font-weight: 300;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: lighter;\n  font-weight: 400;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: normal;\n  font-weight: 500;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: normal;\n  font-style: italic;\n  font-weight: 500;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Medium.ttf') format('truetype');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-SemiBold.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 800;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Black.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 900;\n}\n\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-ExtraBold.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 950;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap');\n\n@font-face {\n  font-family: \"Aller\";\n  src: url(\"~assets/fonts/Aller Light 400.ttf\");\n  font-weight: lighter;\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Aller\";\n  src: url(\"~assets/fonts/Aller 400.ttf\");\n  font-weight: normal;\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Aller\";\n  src: url(\"~assets/fonts/Aller Gras 700.ttf\");\n  font-weight: bold;\n  font-weight: 700;\n}\n\n\n\n","@include keyframes(swing-in-top-fwd) {\n  0% {\n    @include prefix(transform, rotateX(-100deg));\n    @include prefix(transform-origin, top);\n    opacity: 0;\n  }\n\n  100% {\n    @include prefix(transform, rotateX(0deg));\n    @include prefix(transform-origin, top);\n    opacity: 1;\n  }\n}\n\n@include keyframes(swing-out-top-bck) {\n  0% {\n    @include prefix(transform, rotateX(0deg));\n    @include prefix(transform-origin, top);\n    opacity: 1;\n  }\n\n  100% {\n    @include prefix(transform, rotateX(-100deg));\n    @include prefix(transform-origin, top);\n    opacity: 0;\n  }\n}\n\n@include keyframes(flip-in-hor-bottom ) {\n  0% {\n    @include prefix(transform, rotateX(80deg));\n    opacity: 0;\n  }\n\n  100% {\n    @include prefix(transform, rotateX(0));\n    opacity: 1;\n  }\n}\n\n@include keyframes(fadeIn) { \n  from {bottom: 0; opacity: 0;}\n  to {bottom: 30px; opacity: 1;}\n}\n\n@include keyframes(fadeOut) { \n  from {bottom: 30px; opacity: 1;}\n  to {bottom: 0; opacity: 0;}\n}\n\n\n@include keyframes(slideInFromRight) { \n  0% {\n    transform: translateX(360px);\n  }\n\n  100% {\n    transform: translateX(0px);\n  }\n}\n\n@include keyframes(removeCard) { \n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0);\n    display: none;\n  }\n}\n\n@keyframes dropdown-zoom-in {\n  0% {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.98);\n    filter: blur(1px);\n  }\n  60% {\n    opacity: 1;\n    transform: translateY(2px) scale(1.03);\n    filter: blur(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    filter: blur(0);\n  }\n}\n\n@keyframes dropdown-zoom-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.98);\n    z-index: var(--z-index-close);\n  }\n}\n",".a-button {\n  \n  padding: 20px 15px;\n  border-radius: 4px;\n  box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.5);\n  display: inline-block;\n  @include prefix(inline-display, flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n  @include prefix(transition, .35s);\n \n  font-family: $primary-font;\n  font-size: 24px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 28px;\n  border: 2px solid transparent;\n  $parent: &;\n  \n  &[type=\"submit\"] {\n    @extend #{$parent};\n  }\n\n  &:hover {\n    @include prefix(transition, .35s);\n  }\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  &--is-small {\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n    max-width: none;\n    width: auto;\n    padding: 15px 20px;\n  }\n\n  &--full-width {\n    min-width: 100%;\n  }\n\n  &--primary {\n    background-color: $primary-color-500;\n    color: $primary-color-light-500;\n    $primary-button: &;\n    &[type=\"submit\"] {\n      @extend #{$primary-button};\n    }\n\n    &:visited {\n      @extend #{$primary-button};\n    }\n\n    $primary-button-hover: &;\n    &:hover {\n      background-color: $primary-color-light-500;\n      color: $primary-color-500;\n      border: 2px solid $primary-color-500;\n\n      &[type=\"submit\"] {\n        @extend #{$primary-button-hover};\n      }\n    }\n  }\n\n  &--rounded {\n    border-radius: 25px;\n  }\n\n  &__colorable {\n    &--primary {\n      background-color:  $primary-color-light-500;\n      color: $primary-color-500;\n      border: 2px solid $primary-color-500;\n\n      &:hover {\n        color: $primary-color-light-500;\n        background-color: $primary-color-500;\n        border: 2px solid $primary-color-500;\n      }\n    }\n\n    &--secondary {\n      background-color:  $primary-color-light-500;\n      color: $secondary-color-300;\n      border: 2px solid $secondary-color-300;\n\n      &:hover {\n        color: $primary-color-light-500;\n        background-color: $secondary-color-300;\n        border: 2px solid $secondary-color-300;\n      }\n    }\n  }\n}\n",".a-button-link {\n  \n  padding: 5px 10px;\n  border-radius: 4px;\n  @include prefix(display, inline-flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n  @include prefix(transition, .35s);\n \n  font-family: $primary-font;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 20px;\n  border: 2px solid transparent;\n  $parent: &;\n  \n  &[type=\"submit\"] {\n    @extend #{$parent};\n  }\n\n  &:hover {\n    @include prefix(transition, .35s);\n  }\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  @each $color-name in $color-name-list {\n    &[color=\"#{$color-name}\"] {\n      color: map-get($attribute-colors, $color-name);\n\n      &:hover, &.hold, &:focus {\n        border: 2px solid transparent;\n        background-color: map-get($attribute-background-colors, $color-name);\n        color: map-get($attribute-colors, $color-name);\n        @include prefix(transition, .3s);\n      }\n    }\n  }\n}\n",".a-circle-button {\n  width: 31px;\n  height: 31px;\n  border-radius: 50%;\n  @extend .display-inline-flex-center;\n  font-size: 14px;\n  cursor: pointer;\n  @include prefix(transition, .4s);\n  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0);\n  border: 0;\n  position: relative;\n  text-transform: none;\n  &:not(:last-child) {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    border: 0;\n  }\n\n  i {\n    color: inherit;\n    font-size: inherit;\n  }\n\n  &.small {\n    width: 25px;\n    height: 25px;\n    font-size: 12px;\n  }\n\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    &:after {\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      \n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n      min-width: 100%;\n      background-color: $primary-color-dark-900;\n      color: $primary-color-light-500;\n      text-align: center;\n      font-family: $primary-font;\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.4;\n      padding: 6px 8px;\n      border-radius: 6px;\n      top: calc(100% + 10px);\n      left: 50%;\n      transform: translateX(-50%);\n      max-height: 0;\n      opacity: .9;\n      z-index: 100;\n      white-space: nowrap;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      max-width: 400px;\n      width: auto;\n\n      // On small/medium screens, align tooltip to left edge to prevent clipping\n      // Increased breakpoint to 1280px to cover cases where date picker is still visible but sidebar is tight\n      @media screen and (max-width: 1280px) {\n        left: 0 !important;\n        transform: none !important;\n      }\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      visibility: hidden;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n      z-index: 101;\n\n      // On small/medium screens, position arrow near left edge\n      @media screen and (max-width: 1280px) {\n        left: 15px !important;\n        transform: none !important;\n      }\n    }\n\n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n\n  @each $color-name in $color-name-list {\n    &[color=\"#{$color-name}\"] {\n      background-color: map-get($attribute-background-colors, $color-name);\n      color: map-get($attribute-colors, $color-name);\n\n      &:hover {\n        color: map-get($attribute-background-colors, $color-name);\n        background-color: map-get($attribute-colors, $color-name);\n        @include prefix(transition, .4s);\n        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);\n      }\n    }\n\n    &[color=\"#{$color-name}-r\"] {\n      background-color: map-get($attribute-colors, $color-name);\n      color: map-get($attribute-background-colors, $color-name);\n\n      &:hover {\n        color: map-get($attribute-colors, $color-name);\n        background-color: map-get($attribute-background-colors, $color-name);\n        @include prefix(transition, .4s);\n        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);\n      }\n    }\n  }\n}\n",".a-link {\n  color: $primary-color-dark-400;\n  font-family: $primary-font;\n  font-size: 15px;\n  letter-spacing: 0;\n  line-height: 17px;\n  border: none;\n\n  &--underline {\n    text-decoration: underline;\n  }\n\n  &:hover {\n    border: none;\n    color: $primary-color-dark-700;\n  }\n\n  &--display-block {\n    @include prefix(display, block);\n  }\n}\n\na {\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    &:after {\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      bottom: 100%;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n      min-width: 100%;\n      background-color: $primary-color-dark-900;\n      color: $primary-color-light-500;\n      text-align: center;\n      font-family: $primary-font;\n      padding: 10px 10px;\n      border-radius: 6px;\n      top: calc(100% + 10px);\n      max-height: 0;\n      opacity: .8;\n      z-index: 1;\n      white-space: nowrap;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      max-width: 400px;\n      width: auto;\n    }\n\n    &:before {\n      content: \" \";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      visibility: hidden;\n      margin-left: -5px;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n    }\n\n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n}\n",".a-hr-text {\n  line-height: 1em;\n  position: relative;\n  outline: 0;\n  border: 0;\n  color: $primary-color-dark-400;\n  text-align: center;\n  height: 1.5em;\n  opacity: 0.5;\n\n  &:before {\n    content: \"\";\n    background: linear-gradient(to right, transparent, $primary-color-dark-400, transparent);\n    position: absolute;\n    left: 0;\n    top: 50%;\n    width: 100%;\n    height: 1px;\n  }\n\n  &:after {\n    content: attr(data-content);\n    position: relative;\n    display: inline-block;\n    color: $primary-color-dark-400;\n    font-family: $primary-font;\n    font-size: 15px;\n    letter-spacing: 0;\n    padding: 0 0.5em;\n    line-height: 1.5em;\n    color: $primary-color-dark-300;\n  }\n\n  &[data-color=\"light\"]:after {\n    background-color: $primary-color-light-500;\n  }\n\n  &[data-color=\"light-300\"]:after {\n    background-color: $primary-color-light-300;\n  }\n}\n","\n.a-tooltip {\n  position: relative;\n  display: inline-block;\n  margin-top: 0;\n  max-height: 24px;\n  $tooltip: &;\n\n  &.inline-flex {\n    display: inline-flex;\n  }\n\n  &:hover {\n    #{$tooltip}__content {\n      @include z-index(pop-up);\n      visibility: visible;\n      opacity: 1;\n      transform: scale(1) translateX(-50%);\n      @include prefix(transition, \"opacity .3s ease-in-out, transform .2s, top .25s, max-width .4s\");\n    }\n  }\n\n  &.right {\n    #{$tooltip}__content {\n      top: 50%;\n      transform: translateY(-50%);\n      left: 150%;\n      &:after {\n        top: calc( 50% - 10px);\n        left: -15px;\n        margin-left: -5px;\n        transform: rotate(90deg);\n      }\n    }\n  } \n\n  &__content {\n    border-radius: 20px;\n    visibility: hidden;\n    min-width: 360px;\n    max-width: 600px;\n    height: auto;\n    border-radius: 20px;\n    background-color: $primary-color-light-500;\n    box-shadow: 1px 2px 8px 3px $box-shadow-primary-19;\n    position: absolute;\n    z-index: -1;\n    padding: 15px 15px;\n    margin-top: 10px;\n    text-align: left;\n\n\n    @include breakpoint(medium) {\n      min-width: 460px;\n    }\n    \n    opacity: 0;\n    transform: scale(.7);\n    @include prefix(transition, \"opacity .25s ease-in-out, transform .6s, top .7s, z-index .1s 1s, max-width .4s\");\n  \n    /* Position the tooltip text */\n    position: absolute;\n    top: 140%;\n    left: 0;\n    transform: translateX(-50%);\n\n    &__title {\n      @include prefix(display, inline-flex);\n      @include prefix(align-items, center);\n      color: $primary-color-dark-550;\n      font-family: $primary-font;\n      font-size: 18px;\n      font-weight: 600;\n      letter-spacing: 0;\n      line-height: 1.2;\n      margin-top: 0;\n      text-transform: initial;\n    }\n\n    &__text {\n      font-family: $tertiary-font;\n      color: $primary-color-dark-550;\n      font-size: 15px;\n      font-weight: 400;\n      letter-spacing: 0;\n      line-height: 1.35;\n      margin-top: 10px;\n      text-transform: initial;\n    }\n\n    &:after {\n      content: \"\";\n      width: 4px;\n      height: 10px;\n      box-shadow: -1px 0px 10px -5px $box-shadow-primary-7;\n      position: absolute;\n      top: -18px;\n      left: 50%;\n      border-width: 10px;\n      border-style: solid;\n      border-color: $primary-color-light-500 transparent transparent transparent;\n      transform: rotate(180deg);\n      background-color: transparent;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
